export default {
  date: {
    formats: {
      default: '%d/%m/%Y',
      short: '%d de %B',
      long: '%-d de %B de %Y',
      with_day: '%A, %-d de %B',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'Domingo',
      'Segunda',
      'Terça',
      'Quarta',
      'Quinta',
      'Sexta',
      'Sábado',
    ],
    abbr_day_names: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    month_names: [
      null,
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    abbr_month_names: [
      null,
      'Jan.',
      'Fev.',
      'Mar.',
      'Abr.',
      'Maio',
      'Jun.',
      'Jul.',
      'Ago.',
      'Set.',
      'Out.',
      'Nov.',
      'Dez.',
    ],
    order: ['day', 'month', 'year'],
  },
  number: {
    format: {
      separator: ',',
      delimiter: '.',
      precision: 3,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%u%n',
        unit: '€',
        separator: ',',
        delimiter: '.',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'cad',
      AUD: 'aud',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: '',
        format: '%n %',
      },
    },
    precision: {
      format: {
        delimiter: '',
      },
    },
    human: {
      format: {
        delimiter: '',
        precision: 1,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: {
            one: 'Byte',
            other: 'Bytes',
          },
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: '',
          thousand: 'mil',
          million: {
            one: 'milhão',
            other: 'milhões',
          },
          billion: {
            one: 'mil milhões',
            other: 'mil milhões',
          },
          trillion: {
            one: 'bilião',
            other: 'biliões',
          },
          quadrillion: {
            one: 'mil biliões',
            other: 'mil biliões',
          },
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'meio minuto',
      less_than_x_seconds: {
        one: 'menos de 1 segundo',
        other: 'menos de %{count} segundos',
        few: 'less than %{count} seconds',
        many: 'less than %{count} seconds',
      },
      x_seconds: {
        one: '1 segundo',
        other: '%{count} segundos',
        few: '%{count} seconds',
        many: '%{count} seconds',
      },
      less_than_x_minutes: {
        one: 'menos de um minuto',
        other: 'menos de %{count} minutos',
        few: 'less than %{count} minutes',
        many: 'less than %{count} minutes',
      },
      x_minutes: {
        one: '1 minuto',
        other: '%{count} minutos',
        few: '%{count} minutes',
        many: '%{count} minutes',
      },
      about_x_hours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente %{count} horas',
        few: 'about %{count} hours',
        many: 'about %{count} hours',
      },
      x_days: {
        one: '1 dia',
        other: '%{count} dias',
        few: '%{count} days',
        many: '%{count} days',
      },
      about_x_months: {
        one: 'aproximadamente 1 mês',
        other: 'aproximadamente %{count} meses',
        few: 'about %{count} months',
        many: 'about %{count} months',
      },
      x_months: {
        one: '1 mês',
        other: '%{count} meses',
        few: '%{count} months',
        many: '%{count} months',
      },
      about_x_years: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente %{count} anos',
        few: 'about %{count} years',
        many: 'about %{count} years',
      },
      over_x_years: {
        one: 'mais de 1 ano',
        other: 'mais de %{count} anos',
        few: 'over %{count} years',
        many: 'over %{count} years',
      },
      almost_x_years: {
        one: 'quase 1 ano',
        other: 'quase %{count} anos',
        few: 'almost %{count} years',
        many: 'almost %{count} years',
      },
      x_years: {
        one: '1 ano',
        other: '%{count} anos',
      },
      x_weeks: {
        one: '1 semana',
        other: '%{count} semanas',
        few: '%{count} weeks',
        many: '%{count} weeks',
      },
      x_hours: {
        one: '1 hora',
        other: '%{count} horas',
      },
    },
    prompts: {
      year: 'Ano',
      month: 'Mês',
      day: 'Dia',
      hour: 'Hora',
      minute: 'Minuto',
      second: 'Segundo',
    },
  },
  page: {
    plus: {
      button: {
        text: 'Atualizar para Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Até cinco imagens diferentes',
        best_2: 'JPEG ou PNG',
        best_3: 'Até %{size}',
        best_4: '%{resolution} píxeis ou mais',
        best_5: 'GIFs ou vídeos não são aceites (desculpa)',
        best_title: 'As partes importantes:',
        text: 'Destaca-te a ti e à tua marca com cinco fundos de ecrã ou imagens rotativos:',
        best_five: '%{videoResolution} píxeis para vídeos',
        best_four: '%{resolution} píxeis para imagens',
        best_one: 'Até cinco vídeos ou imagens',
        best_six:
          'Os papéis de parede mudam a cada %{rotationInterval} segundos, os vídeos mais compridos que %{rotationInterval} segundos vão ser encurtados',
        best_three: '%{size} máximo por vídeo/imagem',
        best_two: 'JPEG, PNG ou MP4',
        notice:
          "Refuem os tambores! Os fundos de ecrã com vídeo já chegaram! <a href='/profile'>Cria o teu vídeo de fundo de ecrã agora</a>.",
      },
      upsell: {
        benefit_one_alt: 'Obtém a tua própria página do WeTransfer',
        heading_alt: 'Entrega o teu trabalho em estilo',
        benefit_one: 'Obtém o teu próprio domínio WeTransfer',
        benefit_three: 'Faz o design dos teus e-mails de transferência',
        benefit_two:
          'Exibe fundos personalizados durante a descarga dos ficheiros',
        button: {
          action: 'Digam-me mais',
        },
        heading: 'Destaca a tua marca com WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Send the best.</strong> Make a great impression every time people download your files.<br /> <strong>Receive with ease.</strong> Anyone can upload files to you as part of your plan.',
        protip: {
          text: '<strong>Pro tip:</strong> Requesting a transfer from someone? Share a special link to pre-fill the description for them.',
          link: 'Learn more',
        },
      },
      pagename: 'Definições do perfil',
      'onboarding-step-two':
        "Apresenta os teus ficheiros com estilo, personaliza o teu perfil WeTransfer e admira o teu novo look em <a href='%{href}'>%{domain}</a>",
      email_backgrounds: 'Fundos de e-mails',
      sent_you_files: 'enviou-te alguns ficheiros',
      email_background_instruction_with_spec:
        'Dá destaque aos teus e-mails de transferências, adicionando uma imagem de fundo.  \nPara obter melhores resultados, usa uma imagem de %{resolution} pixels (tem em atenção que, se a imagem tiver uma resolução superior, temos de cortá-la). O tamanho máximo do ficheiro é de %{size}.   ',
      receiving: 'E-mail do perfil',
      choose_wallpapers: 'Papéis de parede',
      'step-one-banner':
        'Para começares, escolher um URL para a tua página do WeTransfer. Podes sempre alterá-lo mais tarde.',
      description: {
        pro: 'Com a tua página do WeTransfer, podes causar uma grande impressão sempre que as pessoas fazem download dos teus ficheiros. E é para aqui que qualquer pessoa pode enviar-te transferências de 200 GB, no âmbito do teu plano WeTransfer Pro.',
        premium:
          'Com a tua página do WeTransfer, podes causar uma grande impressão sempre que as pessoas fazem download dos teus ficheiros. E é para aqui que qualquer pessoa pode enviar-te transferências sem limite de tamanho de ficheiro, no âmbito do teu plano WeTransfer Premium.',
      },
      'instructions-1': 'Altera o teu nome e URL sempre que precisares.',
      'instructions-2':
        'Depois de escolheres um novo URL, a tua página é atualizada imediatamente.',
      title: 'Edita a tua página',
      profile_url: 'URL do perfil',
    },
    payment: {
      never_actived_retry:
        'A tua conta ainda não está ativa. Conclui o registo para começares a utilizar o <a href="/payment/retry">%{planName}</a>',
      pagename: 'Plano e pagamento',
      autorenew_heading: 'Detalhes de pagamento',
      autorenew_notice:
        'A tua assinatura %{planName} do %{deal} será renovada automaticamente em %{autorenewal_attempt}.',
      will_expire_notice:
        "A tua subscrição Pro vai <span class='payment__notice'>expirar em %{daysBetween} dias</span>. Renova agora a tua conta ou configura uma renovação automática.",
      never_actived_notice:
        'A tua conta ainda não está ativa. <a href="/payment/retry">Conclui o registo para começares a usar o Pro.</a>',
      manual_renewal_expiry_notice: 'A tua conta Pro vai expirar a %{expiry}.',
      to_checkout: 'Ir para a finalização da compra',
      updating: 'A atualizar...',
      yes_disable: 'Sim, continuar',
      review_billing_link: 'Atualizar o teu método de pagamento?',
      autorenew_failed:
        "A tua subscrição Pro de %{deal}/%{period} irá <span class='payment__notice'><strong>expirar em %{daysBetween} dias</strong>. Não foi possível renovar a tua conta – renova a tua conta manualmente até <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Tens a certeza de que pretendes terminar a renovação automática?',
      disable_autorenewal: 'Terminar renovação automática',
      enable_autorenewal: 'Ativar renovação automática',
      renew_now: 'Renovar agora',
      subscription_expired: 'A tua conta Pro expirou.',
      cancel_heading: 'Está na hora de seguir em frente?',
      cancel_info:
        'Nós entendemos, estas coisas acontecem. Após cancelares a tua assinatura, iremos guardar os teus ficheiros durante mais 30 dias (não, não os vamos guardar debaixo da nossa almofada, não digas coisas estranhas), só para o caso de teres esquecido alguma coisa. Também podes voltar a abrir a tua assinatura quando desejares.',
      cancel_info_subscription:
        'Nós entendemos, estas coisas acontecem. Após cancelares a tua assinatura, podes continuar a utilizar a tua conta Pro até %{subscriptionExpiryDate}. Em seguida, vamos guardar os teus ficheiros durante mais 30 dias (não, não os vamos guardar debaixo da nossa almofada, não digas coisas estranhas), só para o caso de teres esquecido alguma coisa. Também podes voltar a abrir a tua assinatura quando desejares.',
      cancel_now: 'Cancelar assinatura',
      cancelling: 'A cancelar...',
      confirm_cancel_subscription:
        'Tem a certeza que deseja cancelar a sua assinatura?',
      confirm_reactivate_subscription:
        'Que escolha excelente! Basta só mais um clique para reativares o teu método de pagamento',
      manual_renewal_in_future_notice:
        'A tua subscrição do Pro de %{deal}/%{period} vai expirar em %{daysBetween} dias. Podes renovar a tua conta manualmente após %{manual_renewal_available_at}, ou ativar a renovação automática agora.',
      reactivate_heading: 'Vamos começar de novo.',
      reactivate_content_top_pro:
        'Podes reativar a tua assinatura %{planName} e será como se nunca tivesses cancelado. Ou podes optar por atualizar para WeTransfer Premium:',
      reactivate_content_top_premium:
        'Podes reativar a tua assinatura %{planName} e será como se nunca tivesses cancelado.',
      reactivate_content_bottom_pro:
        'Se actualizares para Premium, ser-te-á cobrado %{upfront_payment} e poderás começar imediatamente a utilizar o WeTransfer Premium. A tua nova assinatura de %{recurring_payment}/%{interval} será renovada em %{recurring_date}.',
      reactivate_pro: 'Reativar Pro',
      reactivate_premium: 'Reativar Premium',
      reactivate_upgrade_to_premium: 'Upgrade para Premium',
      reactivating: 'A reativar...',
      subscription_cancelled:
        'A sua assinatura foi cancelada e será anulada automaticamente dentro de %{daysBetween} dias.',
      subscription_reactivate_expired_notice:
        'A tua conta no Pro foi cancelada.',
      subscription_reactivate_notice_pro:
        'A tua assinatura %{planName} foi cancelada e terminará dentro de %{daysBetween} dias.',
      subscription_reactivate_notice_premium:
        'A tua assinatura %{planName} foi cancelada e terminará dentro de %{daysBetween} dias.\nMudaste de ideias? Não entres em pânico, é fácil pôr as coisas a funcionar de novo.',
      subscription_reactivate_notice_trial_before:
        'A tua assinatura do %{planName} foi cancelada e terminará em %{daysBetween} dias.Podes continuar a desfrutar do teu teste WeTransfer Premium até ao fim da tua assinatura.',
      subscription_reactivate_notice_trial_after:
        'A tua assinatura %{planName} foi cancelada e terminará dentro de %{daysBetween} dias.\nPodes continuar a desfrutar do teu teste WeTransfer Premium até %{trialExpiryDate}.',
      update_method_link: 'Atualização dos dados de pagamento',
      autorenew_notice_teams:
        'A tua assinatura %{planName}  de %{deal} irá ser renovada automaticamente para a tua equipa de %{number_of_members} membros em %{autorenewal_attempt}.',
      cancellation_cta: 'Cancelar assinatura',
      cancellation_heading: 'Já não necessitas das vantagens do %{planName}?',
      cancellation_heading_trial: 'Cancelar assinatura',
      cancellation_text:
        'Se cancelares a tua assinatura, podes utilizar todas as funções do Pro até %{subscriptionExpiryDate}. Após essa data, a tua conta WeTransfer Pro será convertida numa conta gratuita e as tuas transferências existentes irão expirar 28 dias depois disso.',
      cancellation_text_item_1: 'Enviar até %{transfer_limit}',
      cancellation_text_item_2:
        'Protege as transferências com uma palavra-passe',
      cancellation_text_item_3:
        'Gere e armazena %{storage_limit} transferências',
      cancellation_text_item_4:
        'Endereço URL próprio e página Pro personalizada',
      cancellation_text_item_heading:
        'Uma conta gratuita permite-te apenas enviar %{free_size_limit} por transferência. Já não poderás:',
      cancellation_text_new:
        'Se cancelares a tua assinatura agora, poderás utilizar %{planName} até ao dia %{subscriptionExpiryDate}. Depois disso, sofrerás o downgrade para o plano gratuito.<br /><br />Atenção, quaisquer transferências existentes expirarão o mais tardar 28 dias após o fim da tua assinatura.',
      cancellation_text_teams:
        'Se cancelares a tua assinatura agora, tu e a tua equipa poderão usar o %{planName} até %{subscriptionExpiryDate}.<br /><br />Depois disso, tu e os membros da tua equipa deixarão de poder enviar transferências de ficheiros, criar diapositivos de apresentação e fazer quadros juntos. A tua conta passará para o plano gratuito e só poderás iniciar sessão na tua própria conta do WeTransfer.<br /><br />Atenção, quaisquer transferências existentes expirarão o mais tardar 28 dias após o fim da tua assinatura.',
      premium_trial: {
        feature_list_item_1: 'Transferências sem limite de tamanho',
      },
      premium_upgrade: {
        cta: 'Muda para o Premium',
        description:
          'Vão ser-te cobrados %{upfront_payment} e podes começar imediatamente no WeTransfer Premium. A tua nova assinatura de %{recurring_payment}/%{interval} será renovada em %{recurring_date}.',
        feature_list_item_1: 'Envia transferências sem limite de tamanho',
        feature_list_item_2: 'Armazenamento ilimitado',
        feature_list_item_3: 'Portais e revisões ilimitadas',
        feature_list_item_4: '%{storageLimit} de armazenamento',
        heading: 'Queres fazer um upgrade do teu plano?',
      },
      unpaid_invoices: {
        heading: 'Tens faturas não pagas',
        item: {
          issued_on: 'Emitido em',
          pay_invoice: 'Pagar fatura',
          pending_invoice: 'Pendente...',
        },
        subheading:
          'Parece que houve um problema com os teus pagamentos anteriores. Paga quaisquer faturas pendentes ou a tua assinatura Pro poderá ser cancelada.',
        subheading_2:
          'Se tiveres faturas pendentes, aguarda - tentaremos novamente dentro de alguns dias e estarás pronto para continuar assim que o pagamento for bem sucedido.',
      },
      upgrade_cta: 'Upgrade',
      app_subscription_banner: {
        title: 'Obtiveste a tua assinatura na %{app_name}',
        content:
          'Para veres ou gerires a tua assinatura, inicia sessão na tua conta da %{app_name} no telemóvel ou computador.',
        go_to: 'Aceder',
        learn_more: 'Sabe mais',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Cancelar assinatura',
      cancellation_disclaimer:
        '*Só para te informar que as tuas transferências existentes vão expirar o mais tardar 28 dias após o plano da tua conta ter sido modificado.',
      'current-plan': 'Plano atual',
      'free-forever': 'Sempre gratuito',
      'free-usp-1': 'Envia até 2 GB',
      'free-usp-2': 'Sem armazenamento',
      'free-usp-3': 'As transferências expiram após 7 dias*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'Se cancelar a sua assinatura agora, pode continuar a usar o WeTransfer Pro até <b>%{expiration_date}</b>. Após este prazo a sua conta será modificada para uma conta WeTransfer gratuita - o que, mesmo assim, ainda é uma solução excelente.',
      pagename: 'Já não necessita das vantagens do Pro?',
      'pro-usp-1': 'Envia e recebe até %{transfer_limit}',
      'pro-usp-2': '1 TB de armazenamento',
      'pro-usp-3': 'Decide quando as tuas transferências vão expirar',
      'pro-usp-4':
        '<p>A tua própria <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">página Pro</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Desbloqueia o Paste® Pro e Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Cancelaste a tua assinatura Pro e a tua conta vai ser modificada para uma conta gratuita do WeTransfer após <b>%{ends_at}.</b></p>\n<p>Por favor informa-nos sobre a razão pela qual vais embora, para podermos melhorar o WeTransfer Pro a pensar em ti.</p>',
      reason_header: 'Temos muita pena de ver-te partir',
      cancel: 'Voltar',
      info: 'Conta-nos a razão pela qual nos vais deixar, e vamos continuar a melhorar os nossos serviços do WeTransfer Pro, tendo em conta o teu feedback.',
      pagename: 'Antes de ires embora',
      yes_disable: 'Sim, continuar',
    },
    payment_failed: {
      selected_product: 'Um %{duration} do %{planTier}',
      change: 'Atualizar',
      complete_order: 'Concluir a tua encomenda',
      description: 'Revê os teus detalhes e conclui a encomenda',
      description_error:
        'Ocorreu um problema — revê os teus detalhes e continua para a finalização da compra',
      description_refused:
        'Não foi possível processar o teu pagamento — verifica os teus detalhes de pagamento e tenta novamente',
      discount: 'Desconto',
      product_description: 'Um %{duration} com o WeTransfer Pro',
      title: 'Estás quase lá',
      total: 'Total',
      vat: 'IVA',
      your_details: 'Os teus detalhes',
      your_order: 'A tua encomenda',
      title_error: 'Hmmm... parece ter havido um problema',
      title_refused: 'Hmmm... parece ter havido um problema',
      payment_status_message:
        'O teu pagamento foi bem sucedido, mas algo correu mal, e não pudemos atualizar o teu plano automaticamente. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Entra em contacto com o suporte</a>',
    },
    payment_methods: {
      billed_now: 'Faturado agora',
      info_content: {
        cancel_bullet:
          'Não te preocupes, podes encontrar a opção para cancelar em Configurações de conta > Pagamento.',
        initial_payment_bullet:
          'Após o pagamento inicial, ser-te-ão cobrados %{price} %{interval} (a menos que decidas anular a tua assinatura - mas nunca farias isso, certo? Certo?)',
        update_payment_bullet:
          'Podes sempre atualizar os teus dados de pagamento e/ou dados de faturação antes do teu próximo pagamento ser devido.',
        month:
          '- Após o pagamento inicial, vamos cobrar-te %{price} todos os meses (a menos que decidas cancelar a tua assinatura do Pro, que não vai cancelar, certo? Certo?!)\n- Não te preocupes. A opção de cancelar está em Definições da conta > Pagamento.\n- Podes atualizar o método de pagamento e/ou os dados da empresa antes da data do próximo pagamento.',
        year: '- Após o teu pagamento inicial, ser-te-á cobrado %{price} anualmente (a menos que decidas cancelar a tua assinatura do WeTransfer Pro - mas não farias isso, não é?).\n- Podes cancelar em qualquer altura. Basta ires a Configurações de Conta > Pagamento.\n- Poderás sempre atualizar o teu método de pagamento e/ou os dados da tua empresa antes da próxima data de pagamento.',
      },
      payment_cta: 'Completar pagamento',
      payment_term: {
        monthly: 'uma vez por mês',
        yearly: 'uma vez por ano',
      },
      payment_title: 'Pagamento',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Mensal',
        year: 'Anual',
      },
      subtotal: 'Subtotal',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'O teu método de pagamento',
      bancontact: 'Bancontact',
      card: 'Cartão de crédito',
      card_cvc: 'CVC',
      card_expiration: 'MM / AA',
      card_name: 'Nome do titular do cartão',
      card_number: 'Número do cartão',
      complete_payment: 'Complete o seu pagamento',
      creditcard: 'Cartão de crédito',
      discount: 'Desconto',
      do_not_refresh: 'Por favor não reatualize nem feche esta página',
      ideal: 'iDEAL',
      ideal_info:
        'O iDEAL é um método de pagamento online dos Países Baixos, onde os clientes podem utilizar o seu próprio banco para efetuar o pagamento.',
      info: 'Atualizar os métodos de pagamento',
      payment_in_progress: 'O seu pagamento está a ser processado...',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/mês',
        year: '/ano',
      },
      select_bank: 'Selecione o seu banco',
      select_country: 'Seleciona o teu país',
      sofort: 'SOFORT',
      tax: 'IVA',
      title: 'Seleciona o teu método de pagamento',
      total: 'Total',
    },
    projects: {
      actions: {
        go_back: 'Todos os projetos',
        discard: 'Descartar alterações',
        edit: 'Editar',
        remove_transfer:
          'Eliminar esta transferência? Os ficheiros serão removidos deste projeto e serão enviadas transferências.',
        save: 'Guardar',
        share: 'Partilhar',
      },
      transfer_actions: {
        download: 'Download',
      },
      added_at: 'em %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Copiar link',
        link_copied: 'Link copiado para a área de transferência',
        content_label: 'Copia o link para este projeto',
        list_item_1: 'Download e ver apenas acesso',
        list_item_2: 'O link permanece o mesmo, para sempre',
        title: 'Partilhar projeto',
      },
      content: {
        empty_state:
          'O teu projeto está atualmente vazio. Começa por adicionar alguns ficheiros para iniciar a linha temporal do teu projeto.',
      },
      logo_title: 'Voltar para wetransfer.com',
      logo_tooltip_caption: 'Voltar para WeTransfer',
      timestamp: '%{timeAgo} atrás',
      chat: {
        owner_button_label: 'Psst… Fala connosco',
        owner_offline_greeting:
          'Estamos atualmente offline, mas diz-nos com o que estás a ter problemas e entraremos em contacto contigo dentro de um dia útil.',
        owner_online_greeting:
          'Diz-nos com o que estás a ter problemas e nós entraremos em contato contigo assim que possível',
        receiver_button_label: 'Perguntas? Estamos aqui para ajudar',
        receiver_offline_greeting:
          'Diz-nos com o que estás a ter problemas e nós entraremos em contato contigo assim que possível.',
        receiver_online_greeting:
          'Diz-nos com o que estás a ter problemas e entraremos em contato contigo assim que possível.',
      },
      created_by: 'Criado por %{user}',
      created_by_fallback: 'Criado',
      deliverable_clipboard_modal: {
        content_label: 'Copia o link para este resultado',
        info: 'As pessoas também poderão ver o teu projeto',
        title: 'Partilhar resultado',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'Este não é o projeto que estás à procura…',
        limit:
          'O teu potencial é infinito, mas atingiste o teu limite de caracteres',
        required: 'Sabes o que tens de fazer. Não podes deixar de preencher',
      },
      event: {
        project_created_byline:
          'Adiciona alguns ficheiros para mostrares no que estás a trabalhar.',
        project_created_title: 'Início do projeto',
      },
      file_count: {
        one: '%{count} ficheiro',
        other: '%{count} ficheiros',
      },
      just_now: 'agora mesmo',
      labels: {
        description: 'Descrição',
        name: 'Nome',
        new_name: 'Dá um nome ao teu projeto',
      },
      logo: {
        cta: 'Adicionar um logótipo',
        errors: {
          dimensions:
            'O teu logótipo é mais pequeno do que 220 x 220 px. Experimenta uma imagem maior',
          general: 'Hmm, algo correu mal. Tenta de novo',
          size: 'O teu logótipo é maior do que 5 MB. Tenta um ficheiro menor',
          type: 'O teu logótipo não é um JPEG, GIF, ou PNG. Tenta uma imagem diferente',
        },
        instructions:
          'O teu logótipo pode ter até 5 MB. JPEGs e GIFs funcionam, mas PNGs com um fundo transparente funcionam melhor',
        'instructions-title': 'Exibe a tua marca',
      },
      name_modal: {
        content_label: 'Dá um nome ou renomeia o teu Projeto',
        input_placeholder_0: 'Definitivamente um Leão de Cannes',
        input_placeholder_1: 'Uma cura para a constipação comum',
        input_placeholder_2: 'O crime perfeito',
        input_placeholder_3: 'Eu escrevo canções, não títulos',
        input_placeholder_4: 'Ideia vencedora',
        input_placeholder_5: 'Nova campanha de marca',
        input_placeholder_6: 'Dominação mundial',
        save: 'Guardar',
        text: 'Descreve em que estás a trabalhar.',
        title: 'Dá um nome ao teu projeto',
      },
      new_project_label: 'Iniciar novo projeto',
      noticebar: {
        'button-cancel': 'Cancelar',
        'button-clear-all-files': 'Limpar tudo',
        'button-close': 'Fechar',
        'button-delete': 'Eliminar',
        'button-no': 'Não',
        'button-share': 'Partilhar',
        'button-yes': 'Sim',
        'confirm-cancel': 'Cancelar esta transferência?',
        'confirm-clear-files-deliverable':
          'Limpar todos os ficheiros a partir de <strong><u> %{deliverableName}</u></strong> ?',
        'confirm-complete':
          'Upload completo! Deixa todos saberem que adicionaste mais ficheiros.',
        'confirm-delete-deliverable':
          'Apaga <strong><u> %{deliverableName}</u></strong> e quaisquer ficheiros que te tenham sido enviados?',
        'confirm-first-complete':
          'Upload completo! Partilha este projeto para que os teus ficheiros possam ser descarregados.',
        deliverable_not_found_error: 'Hmm, parece que a entrega foi eliminada',
        general_error: 'Ups, algo correu mal. Por favor tenta novamente.',
      },
      'onboarding-promise': {
        description:
          'Descreve todo o trabalho que irás realizar para um projeto e simplifica a forma como partilhas. Cria uma lista de resultados, depois adiciona ficheiros à medida que progrides - não há mais ligações de download diferentes.',
        title: 'Começa no caminho certo para permaneceres no caminho certo',
      },
      onboarding: {
        banner:
          'Atenção! És um dos poucos escolhidos com acesso a Projetos enquanto este ainda está a ser construído (e melhorado). Podemos contactar-te para obter feedback.',
      },
      pagename: 'Projetos',
      placeholders: {
        description: 'Dá ao teu projeto uma breve descrição',
        loading: 'A carregar...',
      },
      project: {
        notification: {
          name_saved: 'Nome guardado! O teu projeto soa como um vencedor.',
        },
      },
      share_button_label: 'Partilhar',
      unnamed_project_title: 'Projeto sem nome',
      watch_video: 'Ver vídeo',
    },
    transfer: {
      display_name_fallback: 'Transferência sem título',
      does_not_expire: 'sem <u>data de expiração</u>',
      expires_in: 'Expira em <span>%{time}</span>',
      downloaded_at: 'Download feito em %{date}, às %{time}',
      not_downloaded: 'Ainda não foi feito o download',
      email_bounced:
        'Hmm, o endereço de e-mail a quem enviaste este ficheiro não funcionou',
      count_files: {
        one: '%{count} ficheiro',
        other: '%{count} ficheiros',
      },
      sent_datetime: 'Enviado em %{date} às %{time}',
      never_expires: 'Sem data de expiração',
      and_more: 'E mais %{count}',
      read_more: 'mais',
      copy_link: 'copiar link',
      message: 'Mensagem',
      total_downloads: 'Total de downloads',
      sent_to_recipients: {
        one: 'Enviado a %{count} pessoa',
        other: 'Enviado a %{count} pessoas',
      },
      no_transfers: 'Todas as transferências que enviares aparecem aqui',
      add_first_description:
        'Verifica o estado das tuas transferências ou edita, reencaminha ou elimina as mesmas',
      mobile: {
        download: 'Fazer download de todos os ficheiros',
        remove: 'Eliminar transferência',
      },
      delete_datetime: 'Ficheiros apagados em %{date} às %{time}',
      detail: {
        plus_download_stats:
          'Obtém o Pro para veres quantas vezes as tuas transferências foram descarregadas.',
        plus_password_expiration:
          'Obtém o Pro para configurares palavras-passe e datas de expiração para as transferências.',
        plus_transfer_actions:
          'Obtém o Pro para gerir as tuas transferências e elimina-as a qualquer altura.',
        title: 'Os detalhes das tuas transferências',
      },
      download_status_email: '%{count} de %{total} pessoas',
      download_status_email_text: {
        zero: 'Ainda não foi feito o download',
        one: '%{count} de %{total} pessoas',
        other: '%{count}/%{total} pessoas',
      },
      download_status_link: {
        one: 'uma vez',
        other: '%{count} vezes',
      },
      download_status_link_text: {
        zero: 'Ainda não foi feito o download',
        one: '1 vez',
        other: '%{count} vezes',
      },
      sent_moment: 'Enviado em %{moment}',
      total_downloads_tooltip:
        'Diferente do que esperavas? Fizemos recentemente uma pequena mudança. Este número mostra apenas os downloads concluídos.',
      display_name: {
        label: 'Título',
        label_mobile:
          'Adiciona um título para que as pessoas conheçam o conteúdo da tua transferência',
      },
      download_status_received_text: {
        zero: 'Nenhum ficheiro descarregado',
        one: 'Descarregado',
        other: 'Descarregados',
      },
      edit_display_name: {
        cancel: 'Cancelar',
        save: 'Guardar',
        title: 'Título',
      },
      received_datetime: 'Recebido em %{date} às %{time}',
      received_from: 'Recebido de',
      received_moment: 'Recebido em %{moment}',
      teams: {
        received_by: 'Recebido por',
        self: 'por mim',
        sent_by: 'Enviado por',
      },
      title: 'Título',
      set_password: {
        added: 'Adicionada',
        change: 'Alterar',
        remove: 'Remover',
        description:
          'Define uma palavra-passe para controlar quem tem acesso a esta transferência.',
        remove_warning:
          'Remover proteção por palavra-passe desta transferência?',
        yes_remove: 'Sim, remover',
      },
      set_expiration: {
        description:
          'Define uma data de expiração para limitar o acesso a esta transferência.',
        label: 'Expira em',
      },
      anon_upsell_no_account:
        'Para editar ou rastrear os downloads para esta transferência antes de expirar, <a href="%{href}">registe-se</a> gratuitamente.',
      anon_upsell_found_account:
        'Para editar ou rastrear downloads desta transferência antes de ela expirar, <a href="%{href}">faça login</a>.',
      anon_upsell_no_account_with_button:
        'Podes editar esta transferência antes que expire criando uma conta.',
      create_free_account: 'Criar uma conta gratuita',
    },
    transfers: {
      space_used_unlimited: ' %{space} de armazenamento utilizado',
      pagename: 'Transferências',
      search: 'procurar nome de ficheiro',
      search_results: {
        one: '%{count} resultado encontrado',
        other: '%{count} resultados encontrados',
        none: 'Sem resultados',
        retry:
          'Não conseguimos encontrar uma transferência correspondente à tua procura - tenta novamente.',
      },
      space_used: '%{space} de %{totalSpace} utilizados',
      selected_text: {
        one: '%{count} transferência selecionada (%{size})',
        other: '%{count} transferências selecionadas (%{size})',
      },
      last_7_days: 'Enviado nos últimos 7 dias',
      over_7_days: 'Enviado há mais de 7 dias',
      sort_on: 'Ordenar por:',
      size: 'Tamanho',
      name: 'Nome',
      date: 'Data',
      delete: 'Eliminar',
      download: 'Download',
      forward: 'Reencaminhar',
      remove: 'Eliminar',
      select: 'Selecionar',
      copy_link: 'Copiar link',
      sent_time_ago: 'Enviado há %{timeAgo}',
      files: {
        one: '%{count} ficheiro',
        other: '%{count} ficheiros',
      },
      confirm_transfer_delete:
        'Espera – tens a certeza de que pretendes eliminar esta transferência?',
      confirm_forward:
        'Se reencaminhares, irás substituir a transferência em curso. Continuar?',
      confirm_expired_transfer_delete:
        'Isto vai eliminar definitivamente os ficheiros e a informação sobre a transferência. Continuar?',
      deleting_now: 'Agora, vamos eliminar isto',
      deselect_all_transfers: {
        one: 'Desmarcar todas as transferências',
        other: 'Desmarcar todas as %{count} transferências',
      },
      downloads: 'Downloads',
      expiration: 'Data de expiração',
      expiration_next: 'Expira durante os próximos %{days}',
      expiration_no_date: 'Nenhuma data de expiração',
      expiration_not_soon: 'Não expira brevemente',
      include_archived_switch_label:
        'Incluir informações das transferências eliminadas',
      include_archived_switch_tooltip:
        'Estes elementos não contam para o teu limite de armazenamento',
      notify_completed:
        'Transferência completada. Agora, podes fechar esta janela, também podes deixá-la aberta.',
      preview: 'Pré-visualizar',
      remove_permanently: 'Eliminar informações definitivamente',
      search_placeholder: 'Procura por nome de ficheiro ou por e-mail',
      select_all_transfers: {
        one: 'Selecionar todas as transferências',
        other: 'Selecionar todas as %{count} transferências',
      },
      space_left: '%{space} de %{totalSpace} restante',
      teams_tip: {
        subtitle:
          'Esta página mostra a tua atividade de transferências. Para o caso de estares a perguntar-te, os membros da tua equipa só conseguem ver as suas próprias transferências.',
        title: 'A tua equipa Pro está a crescer…',
      },
      title: 'Transferências enviadas',
      view_details: 'Visualizar detalhes',
      edit_display_name: 'Modificar título',
      received_time_ago: 'Recebido há %{timeAgo}',
      search_title_placeholder:
        'Procurar por título, nome do ficheiro ou e-mail',
      see_all: 'Ver todos (%{count})',
      sender: 'Remetente',
      sort_by_title: 'Título',
    },
    accountinfo: {
      pagename: 'Informação da conta',
      signed_in_as: 'Sessão iniciada como %{name}',
      sign_out: 'Terminar sessão',
      paid_on: 'Pago em',
      no_invoices:
        'Os teus recibos irão aparecer aqui, mas aparentemente ainda não tens nenhum recibo. Que sorte!',
      subscription_info:
        'A tua subscrição Pro de %{deal} será renovada automaticamente em %{autorenewal_attempt}.',
      payment_success: {
        monthly:
          'Ótimo, podes agora usufruir do WeTransfer Pro por um mês inteiro',
        monthly_renewal: 'Ótimo, podes agora usufruir do Pro por mais um mês',
        yearly:
          'Ótimo, podes agora usufruir do WeTransfer Pro por um ano inteiro',
        yearly_renewal: 'Ótimo, podes agora usufruir do Pro por mais um ano',
      },
    },
    changepassword: {
      pagename: 'Alterar palavra-passe',
    },
    invoices: {
      pagename: 'Recibos',
    },
    reviewbilling: {
      pagename: 'Confirma os teus detalhes de pagamento',
      information:
        'Para alterar o teu método de pagamento, tens de renovar a tua subscrição ao mesmo tempo',
      information_payment:
        'Serão cobrados %{deal} pelo próximo %{period} do Pro – a tua subscrição será válida até %{expiry}',
    },
    renewbilling: {
      pagename: 'Revê as tuas informações e renova',
    },
    link_downloads_unsubscribe: {
      body: 'Podes cancelar a tua inscrição das notificações sobre os downloads das tuas transferências - e, mesmo assim, podes acompanhar os teus downloads no painel de ficheiros enviados.',
      cta: 'Ir para as minhas transferências enviadas',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Escolher da galeria',
        },
        next_button: 'Tudo pronto',
        description:
          'Escolhe uma imagem de padrão de fundo e decide qual será o aspeto das tuas páginas de perfil e de download. Fantástico, não é? Podes carregar as tuas próprias imagens, ou nós fornecemos algumas opções.',
      },
      upload_wallpaper: {
        add_text: 'Carregar uma imagem',
        add_description:
          'Para os melhores resultados possíveis, sugerimos que carregues uma imagem de 2560 x 1600 pixels. O tamanho máximo de ficheiros é de 3 MB.',
        upload_text: 'Carregar uma imagem ou vídeo',
      },
      preview: {
        wallpaper_credits_prefix: 'Padrão de fundo por',
      },
      1: {
        description:
          '&quot;Personaliza o que as pessoas veem sempre que lhes enviares ficheiros. E com a tua própria página do WeTransfer, qualquer pessoa te pode enviar %{transfer_limit} de transferências—basta dar-lhes o teu URL. O teu endereço de e-mail será apresentado na página para que as pessoas possam confiar que os respetivos ficheiros serão enviados para ti.<br /><br />\nPrimeiro, escolhe o teu URL.&quot;',
        next: 'Seguinte',
        skip: 'Saltar',
        warning:
          '<strong> Cuidado,</strong> isto só pode ser definido uma vez (mas não te queremos pressionar!)',
        'blurb-1':
          'Cria a tua página do WeTransfer para um visual profissional quando alguém fizer download dos teus ficheiros e torna (ainda) mais fácil o envio de transferências para ti.',
        'blurb-2': 'Primeiro, escolhe o teu URL.',
        welcome: 'Marca presença com a tua própria página no WeTransfer',
        information:
          'Não te preocupes, podes sempre alterá-lo mais tarde em <strong>Branding</strong>.',
        description_unlimited:
          'Personaliza o que as pessoas vêm sempre que lhes envias ficheiros. E, com a tua própria página no WeTransfer, todos te podem enviar transferências de qualquer tamanho - basta dares-lhes o teu endereço URL. O teu endereço de e-mail irá ser mostrado na página para que as pessoas possam confiar que os seus ficheiros serão enviados para ti.<br /><br /> \nEm primeiro lugar, escolhe o teu endereço URL.',
      },
      2: {
        description:
          'Podes selecionar até cinco fundos de ecrã (ou wallpapers, como gostamos de lhes chamar) para o teu perfil.\n\nDestaca-te a ti ou à tua empresa e envia os teus ficheiros com estilo',
        pick: 'Escolhe da galeria',
        title: 'Deixa uma impressão com cada transferência',
        upload: 'Carrega os teus próprios',
      },
      3: {
        description:
          'O link <strong>%{customLink}</strong> já está configurado. Agora podes adicionar este link ao teu Website para as pessoas te enviarem transferências de até %{transfer_limit}—ou te enviarem coisas.',
        done: 'Terminado',
        title: 'Que perfil tão giro',
        description_unlimited:
          '<strong>%{customLink}</strong> foi configurado. Agora podes adicionar este link ao teu site para que as pessoas te possam enviar ficheiros de qualquer tamanho - ou podes, se quiseres, ir enviar ficheiros.',
      },
    },
    contact: {
      add_contact: 'Adicionar contacto',
      add_first_description:
        'Também guardamos aqui os endereços de e-mail a quem envias ficheiros',
      add_to_transfer: 'Adicionar à transferência',
      remove_from_transfer: 'Remover da transferência',
      confirm_delete: {
        one: 'Tens a certeza de que pretendes eliminar este contacto?',
        other: 'Tens a certeza de que pretendes eliminar %{count} contactos?',
      },
      contact_count: {
        one: '%{count} contacto',
        other: '%{count} contactos',
      },
      edit: 'Editar',
      mobile: {
        add: 'Adicionar contacto',
      },
      no_contacts: 'Adiciona o teu primeiro contacto!',
      pagename: 'Contactos',
      remove: 'Eliminar',
      search_count: {
        one: '%{count} resultado encontrado',
        other: '%{count} resultados encontrados',
      },
      search_placeholder: 'procurar e-mail, nome ou empresa',
      select: 'Selecionar',
      selected_text: {
        one: '%{count} contacto selecionado',
        other: '%{count} contactos selecionados',
      },
      teams_tip: {
        subtitle:
          'Ao enviares uma transferência para alguém, iremos adicionar essa pessoa à tua lista de contato. Todas as pessoas na tua equipa podem criar uma lista.',
        title: 'A tua equipa Pro está a crescer…',
      },
    },
    unsubscribeexpiration: {
      button: 'Anular a subscrição',
      button_unsubscribed: 'Voltar ao WeTransfer',
      description:
        'Não queres receber mais e-mails nossos? Não há problema, podemos deixar de lembrar-te sobre as transferências que estão prestes a expirar.',
      description_unsubscribed:
        'Vais deixar de receber e-mails com notificações sobre transferências que estão a ponto de expirar.',
      no_email: 'ti',
      title: 'Anular a subscrição de e-mails com lembretes',
      title_unsubscribed: 'Já está!',
      downloaded: {
        body: 'Tudo bem, nós percebemos. Podes cancelar a tua inscrição de quaisquer e-mails sobre transferências a ponto de expirar após os ficheiros terem sido descarregados. Isto não tem qualquer influência sobre e-mails enviados caso ninguém tenha descarregado os teus ficheiros.',
        cta: 'Cancelar inscrição',
        title:
          '"Os meus ficheiros foram descarregados, não preciso de receber e-mails sobre transferências a ponto de expirar"',
      },
      not_downloaded: {
        body: 'Não há problema. Podes cancelar a tua inscrição de quaisquer e-mails sobre transferências a ponto de expirar, mesmo se ainda ninguém tiver descarregado os teus ficheiros.',
        cta: 'Cancelar inscrição',
        title:
          'Não queres receber e-mails sobre transferências a ponto de expirar?',
      },
      pro: {
        body_1:
          'Tudo bem, podes cancelar a tua inscrição destes e-mails de notificação. Nos detalhes da tua transferência ainda vais poder monitorizar quando as transferências vão expirar e modificar as datas de expiração sempre que desejares.',
        body_2:
          'Psst, podes contactar-nos em <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> se mudares de ideias ou se tiveres algum problema, não nos importamos!',
        cta: 'Cancelar inscrição',
        title:
          'Não queres receber e-mails sobre transferências a ponto de expirar?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Tens a certeza de que queres limpar os teus cookies?',
        },
      },
    },
    about_plus: {
      checklist: {
        title:
          'Faz o upgrade para o Pro ainda hoje, por %{currency}%{price} por mês',
      },
    },
    advertise: {
      gallery: {
        preview: 'Pré-visualizar',
      },
      guidelines: {
        advert_static: {
          title: 'Fundo de ecrã estático',
        },
      },
    },
    billinginfo: {
      pagename: 'dados de faturação',
    },
    help: {
      button_all_answers: 'Mais respostas',
      page_title: 'Ajuda rápida',
      read_more: 'Ler mais',
      search_button: 'Pesquisar',
      search_placeholder: 'Em que te podemos ajudar?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'A carregar...',
    },
    payment_update: {
      bancontact: {
        info: 'Informação - para verificar se os teus dados estão corretos, o Bancontact vai cobrar uma taxa única de 0,50 €',
      },
      confirm_update: 'Confirmar',
      ideal: {
        info: 'Informação - para verificar se os teus dados estão corretos, o iDEAL vai cobrar uma taxa única de 0,01 €.',
      },
      info: 'Informação - para verificar se os teus dados estão corretos, o iDEAL vai cobrar uma taxa única de 0,01 €.',
      sofort: {
        info: 'Informação - para verificar se os teus dados estão corretos, o SOFORT vai cobrar uma taxa única de 1 €',
      },
      title: 'Atualização dos dados de pagamento',
      update_in_progress: 'A atualizar os teus dados...',
    },
    sign_in: {
      account: 'Não tens uma conta?',
      upgrade: 'Mude para o WeTransfer Pro',
    },
    signin: {
      account_cta: 'Criar uma conta',
      account_item_1: 'Enviar até %{size_limit}',
      account_item_2: 'Gerir transferências',
      account_item_3: 'Armazenar até %{storage_limit}',
      account_subtitle: 'Gratuita',
      plus_cta: 'Obtém o WeTransfer Pro',
      plus_item_1: 'Envia até %{size_limit}',
      plus_item_2: 'Gerir transferências',
      plus_item_3: 'Armazena até %{storage_limit}',
      plus_item_4: 'Os teus próprios fundos de ecrã',
      plus_item_5: 'Uma URL personalizada',
      plus_item_6: 'Protege transferências com uma palavra-passe',
      plus_month: '/mês',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Cancelar convite',
      },
      invitees: {
        title: 'Convite enviado - a aguardar resposta',
      },
      member: {
        action_demote: 'Eliminar como administrador',
        action_promote: 'Tornar administrador',
        action_revoke: 'Retirar da equipa',
      },
      members: {
        title: 'Na sua equipa',
      },
      no_access: {
        description:
          'Fique ligado, iremos informá-lo de quando tudo estiver pronto. ',
        title: 'Ups, parece que esta função ainda é um grande segredo... ',
      },
      subtitle: {
        members: {
          one: '%{count} membro',
          other: '%{count} membros',
        },
        pending: '%{pendingCount} convidados',
      },
      tip: {
        button: 'Fique a saber mais',
        subtitle:
          'Com a nossa função Pro para Equipas, criámos a melhor experiência WeTransfer, e aperfeiçoá-mo-la ainda mais! Adicione novos membros gratuitamente. Utilize o formulário simplificado abaixo para manter a sua equipa em movimento - após eles terem aceite o seu convite, você está pronto a partir!',
        title: 'Numa equipa, quem conta é o grupo e não o indivíduo...',
      },
      title: 'Equipa',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Expira dentro de %{expiry}',
      },
      recipients: 'A enviar para',
      upsell: {
        benefit_one: 'Vê quando os ficheiros foram transferidos',
        benefit_three: 'Revê e reenvia transferências passadas',
        benefit_two: 'Vê quem transferiu os teus ficheiros',
        button: {
          action: 'Quero saber mais',
          cancel: 'Não, obrigado',
        },
        heading: 'Gere facilmente as tuas transferências com o WeTransfer Pro',
        title: 'Os detalhes da tua transferência',
      },
    },
    transferReceived: {
      'empty-description':
        'Aqui encontram-se as transferências enviadas para ti - não te preocupes, elas não vou ocupar espaço',
      'empty-title': 'Rastreio de transferências',
    },
    unsubscribeonboarding: {
      action: 'Anular inscrição',
      back: 'Regressar ao WeTransfer',
      contact:
        'Se te deparares com um obstáculo, envia-nos um mail para <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> - sem qualquer problema.',
      done: 'Já está!',
      message:
        'Cancela a tua inscrição para os nossos e-mails introdutórios - não te preocupes, ainda vais receber os e-mails importantes.',
      title: 'A tua caixa de entrada está a ser invadida?',
    },
    userinfo: {
      pagename: 'Dados pessoais',
    },
    free_onboarding: {
      close: 'Fechar',
      finish_tour: 'Terminado',
      next: 'Seguinte',
      send_files: 'Basta dirigires-te para enviar ficheiros',
      start_tour: 'Vê o que temos mais para oferecer',
      step_one: {
        body_1:
          'Agora que verificaste o endereço de e-mail para a tua conta, não é preciso fazê-lo sempre que transferires. Diz adeus aos códigos de verificação!',
        body_2:
          'Mantém um registo de todas as tuas transferências enviadas e recebidas num único local. Vê quantas vezes os teus ficheiros são descarregados. Reenvia, encaminha, ou apaga as tuas transferências com um clique.',
        header_1: 'Verificado de uma vez por todas',
        header_2: 'Gere as tuas transferências',
        subtitle:
          'Diz adeus aos códigos de verificação e links de descarregamento perdidos. A tua nova conta dá-te a forma mais fácil de enviar grandes ficheiros - gratuitamente.',
        title_1: 'Envia ficheiros <strong>à tua maneira</strong>',
        title_2: 'com o WeTransfer',
      },
      step_three: {
        body_1:
          'Quer se trate de um vídeo no teu telefone ou de um link no teu computador, guarda toda a tua inspiração num só lugar. Para começar, abre o Collect com o lançador (é o que está no canto superior esquerdo) ou usa o link abaixo.',
        cta: 'Vai para o Collect',
        title_1: '<strong>Guarda inspiração</strong> à medida que avanças',
        title_2: 'com o Collect',
      },
      step_two: {
        body_1:
          'Apresenta ideias. Mostra o teu trabalho em progresso. Mantém-te sincronizado. Sem nunca mais teres de formatar outro diapositivo. Para começares, abre o Paste com o lançador (aquela coisa no canto superior esquerdo) ou usa o link abaixo.',
        cta: 'Vai para o Paste',
        title_1: 'Cria <strong>diapositivos em segundos</strong>',
        title_2: 'com Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Experimenta o portals',
        pill: 'Funcionalidade novinha em folha',
        text: 'Aqui estão os <strong>portals</strong>, a forma mais simples de terminar projetos. Convida clientes e colaboradores para visualizarem ficheiros e selecionarem favoritos - sem ser necessário descarregar.',
        title: 'Partilha trabalho. Obtém feedback. Tudo num só lugar.',
      },
    },
    not_found: {
      body: 'Volta para <a href="https://wetransfer.com/">wetransfer.com</a> ou anima os teus olhos com algumas <a href="https://wepresent.wetransfer.com/">coisas bonitas que escrevemos</a> .',
      image_alt: 'Algo correu mal',
      title: 'Não foi possível encontrar essa página.',
    },
    password_and_security: {
      title: 'Palavra-passe e segurança',
      'two-factor-authentication': {
        description: {
          enabled: 'Desde %{date}',
        },
        disable: 'Desligar',
        done: 'Terminado',
        enable: 'Liga',
        get_recovery_codes: 'Obter códigos de recuperação',
        next_step: 'Seguinte',
        recovery_code_action: 'Criar novos códigos',
        recovery_code_keep_safe:
          'Cada um dos códigos só pode ser utilizado uma vez, mas se desejares podes obter mais códigos.',
        recovery_code_need_more:
          'Necessitas de mais códigos de recuperação? Podes sempre criar mais códigos, mas lembra-te que isto vai invalidar os códigos já existentes.',
        recovery_code_title: 'Os teus códigos de recuperação',
        require_password_action: 'Entrar',
        require_password_text: 'Insere a tua palavra-passe para continuar',
        step_one_action: {
          app_store: 'Descarregar na App Store',
          google_play: 'Obter no Google Play',
        },
        step_one_label: 'Passo 1 (de 3)',
        step_one_text:
          'Vais necessitar de uma aplicação authenticator no teu telefone. Se já tiveres o Google Authenticator (ou uma aplicação diferente), clica em "seguinte".',
        step_one_title: 'Descarregar o Google Authenticator',
        step_three_label: 'Passo 3 (já está!)',
        step_three_text:
          'Se precisares de te conectar e não tiveres o teu telemóvel contigo (já ouvimos dizer que isso acontece), podes usar um destes códigos de recuperação. Não iremos guardar estes códigos nem voltar a partilhá-los contigo, portanto anota-os agora - e mantém-nos seguros, como se se tratasse do código de acesso à tua conta bancária.',
        step_three_text_2:
          'Mantém estes códigos tão seguros como a palavra-passe da tua conta bancária! Cada um dos códigos só pode ser utilizado uma única vez.',
        step_three_title: 'Guardar códigos de recuperação',
        step_two_form: {
          error: 'Ups, este código está errado ou já não é válido.',
          label: 'Código de verificação',
        },
        step_two_label: 'Passo 2 (já vamos a meio)',
        step_two_text:
          'Utiliza a tua aplicação de autenticação para digitalizar este código de barras. A aplicação irá criar um código de verificação com seis dígitos; insere este código abaixo.',
        step_two_text_mobile:
          'Insere esta chave na tua aplicação de autenticação. A aplicação vai gerar um código de verificação com seis dígitos. Insere este código abaixo.',
        step_two_title: 'Ler o código de barras',
        step_two_title_mobile: 'Inserir chave',
        text: {
          protect_account:
            'Utiliza o teu telemóvel e protege a tua conta com uma camada extra de segurança.',
        },
        title: 'Autenticação em duas etapas',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Obtém o melhor do Paste® e do Collect',
      },
      cta: 'Não, quero continuar no Pro',
      'cta-2': 'Cancelar a minha assinatura',
      disclaimer: {
        collect:
          'O teu espaço de armazenamento irá passar de 200 GB a 5 GB no Collect',
        paste:
          'Irás passar de conjuntos de apresentação ilimitados para 3 conjuntos no Paste®',
        'team-member': 'Serás retirado de %{currentTeam} na WeTransfer Pro.',
        teams:
          'A tua equipa de %{amountOfMembers}vai ser eliminada de %{currentTeam} no WeTransfer Pro',
        title:
          'Quando a tua assinatura atual expirar em <strong>%{date}</strong>:',
        'transfer-expiry':
          'As tuas transferências existentes serão eliminadas após 28 dias',
        'transfer-team-member':
          'Não poderás enviar e receber transferências como parte da equipa e não poderás gerir as transferências de equipas existentes.',
      },
      'password-expiry': {
        title:
          'Protege as tuas transferências com uma palavra-passe e decide quando elas expiram',
      },
      personalization: {
        title: 'Personaliza a tua página do WeTransfer',
      },
      portals: {
        text: 'Com o %{planName}, podes utilizar os <a href="%{href}" target="_blank">portais</a> para partilhares trabalho para os clientes reverem—sem necessidade de downloads.',
        title: 'Partilha o teu trabalho e obtém feedback num único lugar',
      },
      'stay-pro': 'Manter assinatura',
      'storage-limit': {
        title: 'Desfruta de %{storage_limit_pro} de armazenamento por pessoa',
      },
      subtitle:
        'Se cancelares agora, a partir de %{date} vais deixar de poder:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Convidar os membros da equipa</a> a enviar, receber e gerir transferências em conjunto - ou trabalhar sozinho gratuitamente.',
        'team-member-text':
          'Vamos remover-te da tua equipa e vais deixar de poder aceder, receber ou gerir transferências.',
        'team-owner-text':
          'Tens <a href="%{href}" target="_blank">%{amountOfMembers} membros na tua equipa</a> que já não poderão enviar, receber ou gerir transferências em conjunto.',
        title: 'Trabalha em equipa nas grandes ideias',
      },
      title: 'Tens mesmo a certeza de que pretendes desistir do %{planName}?',
      'transfer-limit': {
        text: 'Atualmente, podes enviar e receber transferências maiores—mais do que os %{transfer_limit_free} gratuitos.',
        title: 'Enviar transferências 100 vezes maiores',
      },
      'transfer-unlimited': {
        text: 'Podes enviar (e receber) transferências sem limites de tamanho - infinitamente mais do que o limite gratuito de %{transfer_limit_free}.',
        title: 'Enviar transferências de qualquer tamanho',
      },
    },
    pricing: {
      pro: {
        per_person: 'por pessoa',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Criar conta',
        current_plan: 'Plano atual',
        sign_up: 'Registar',
        switch_premium: 'Mudar para o Premium',
        switch_pro: 'Mudar para o Pro',
        upgrade: 'Fazer o upgrade',
      },
      faq: {
        answers: {
          answer_1:
            'Poderás começar a utilizar WeTransfer Pro ou WeTransfer Premium assim que tiveres completado o teu pagamento. Enviar-te-emos também um e-mail de confirmação com a tua factura paga em anexo. <br /><br /> \n \nUma vez na tua conta, poderás enviar transferências maiores, começar a usar o Portals, e criar a tua própria página no WeTransfer imediatamente. Se tiveres alguma transferência anterior que tenha sido enviada enquanto estavas no plano gratuito, também poderás alterar as datas de validade para quando quiseres.',
          answer_2:
            'Quando utilizas o WeTransfer, qualquer pessoa pode descarregar os seus ficheiros - não há necessidade de iniciar sessão ou de se inscrever. Os destinatários terão de aceitar os nossos Termos de Serviço e podemos pedir-lhes que aceitem cookies, mas é só isso! <br /><br /> \n \nSe quiseres partilhar trabalho ou colaborar no Portals (a mais recente funcionalidade do WeTransfer), os teus clientes e colaboradores não precisarão de se inscrever para ver e seleccionar ficheiros, adicionar comentários, dar aprovação, ou descarregar ficheiros. Só precisarás de adicionar membros da equipa ao teu plano Pro ou Premium se quiseres que as pessoas possam adicionar comentários e criar portais contigo.',
          answer_3:
            'Com um plano Pro ou Premium, podes criar a tua própria página no WeTransfer, onde qualquer pessoa pode enviar-te ficheiros com o limite do tamanho da transferência do teu plano. Isso significa que podes obter os ficheiros grandes de que necessitas dos clientes ou colaboradores, e eles não precisarão de ter uma conta - apenas o URL para a tua página (embora possamos pedir-lhes que verifiquem o seu endereço de e-mail para os proteger de "príncipes estrangeiros" que "queiram enviar-lhes dinheiro").',
          answer_4:
            'Primeiro, terás de te inscrever no WeTransfer Pro ou WeTransfer Premium - não podes adicionar membros da equipa enquanto estiveres no plano gratuito. E qualquer que seja o plano que escolheres, os membros da tua equipa desfrutarão de todos os mesmos benefícios (para que não possas obter Premium para ti e ter alguns membros da equipa no Pro, por exemplo). Os membros da equipa poderão enviar e receber transferências maiores a partir da tua página WeTransfer, e gerir transferências a partir de um resumo geral partilhado. <br /><br /> \n \nDepois de te inscreveres no plano que é melhor para a tua equipa, poderás convidar tantos membros da equipa quantos quiseres a partir das configurações de gestão da tua equipa. Podes adicionar e remover membros da tua equipa em qualquer altura enquanto a tua assinatura estiver ativa.',
          answer_5:
            'Aceitamos PayPal assim como cartões de crédito das principais redes como Visa, Mastercard, e American Express. Também apoiamos outros sistemas de pagamento em linha em alguns países. <br /><br /> \n \nNão aceitamos transferências bancárias diretas porque tens de te inscrever para uma assinatura anual ou mensal recorrente. (Enviamos-te um e-mail antes de isto acontecer pela primeira vez, para te avisarmos).',
          answer_6:
            'Se não tiveres o armazenamento ilimitado com o WeTransfer Premium, terás de limpar algum espaço de armazenamento eliminando algumas das tuas transferências enviadas ou actualizando o teu plano. Enquanto não o fizeres, não poderás enviar novas transferências. <br /><br /> \n \nSe estiveres a utilizar o WeTransfer gratuito, todas as tuas transferências de até 2 GB são automaticamente apagadas após 7 dias. Portanto, não te preocupes, não é possível ultrapassar o teu limite de armazenamento.',
          answer_6_variant_asterisk:
            'Tens de libertar espaço de armazenamento eliminando algumas das tuas transferências enviadas ou fazendo um upgrade ao teu plano. Enquanto não o fizeres, não poderás enviar novas transferências. <br /><br />\n\nSe tiveres uma assinatura Premium e atingires 5 TB, podes entrar em contacto com a nossa equipa de apoio e pedir mais espaço de armazenamento até um limite máximo anual de 15 TB. <br /><br />Se estiveres a utilizar o WeTransfer grátis, todas as tuas transferências enviadas de até 2 GB são automaticamente apagadas após 7 dias. Portanto, não te preocupes, não é possível ultrapassares o teu limite de armazenamento.',
          answer_6_variant_limited_storage:
            'Terás de libertar algum espaço de armazenamento eliminando algumas das tuas transferências enviadas ou fazendo um upgrade ao teu plano, (a menos que tenhas uma assinatura Premium). Enquanto não o fizeres, não poderás enviar novas transferências. <br /><br />\n\nSe estiveres a utilizar o WeTransfer grátis, todas as tuas transferências enviadas de até 2 GB são automaticamente apagadas após 7 dias. Portanto, não te preocupes, não é possível ultrapassares o teu limite de armazenamento.',
          answer_7:
            'A tua assinatura será renovada automaticamente (enviar-te-emos um e-mail antes de isto acontecer pela primeira vez), mas podes cancelar a qualquer momento. <br /><br /> \n \nPara mudar para a utilização gratuita do WeTransfer, tudo o que precisas de fazer é ir às tuas configurações de <strong>Conta</strong> e cancelar a tua assinatura. Tu (e qualquer membro da equipa que possas ter) poderás continuar a utilizar o teu plano Pro ou Premium até ao fim do teu período de assinatura atual.',
          answer_8:
            'Milhões de pessoas em todo o mundo confiam no WeTransfer e no nosso conjunto de ferramentas para mover ideias. Todos os meses, 80 milhões de pessoas partilham 2 mil milhões de ficheiros apenas na nossa plataforma de partilha de ficheiros. <br /><br /> \n \nPara manter as tuas ideias a salvo de ataques ou exploração, os teus ficheiros são encriptados quando são transferidos (TLS) e quando são armazenados (AES-256). Uma vez armazenados, os teus ficheiros só podem ser acedidos utilizando os links únicos enviados para o remetente e destinatário.',
        },
        questions: {
          question_1: 'O que acontece após a minha inscrição e pagamento?',
          question_2: 'Os meus destinatários têm de se inscrever?',
          question_3:
            'Posso receber transferências maiores de todos os remetentes? ',
          question_4: 'Como devo adicionar (e eliminar) membros de uma equipa?',
          question_5: 'Que métodos de pagamento posso utilizar?',
          question_6:
            'O que acontece se eu ultrapassar o meu limite de armazenamento?',
          question_7: 'Como devo proceder para cancelar?',
          question_8:
            'Posso confiar no WeTransfer? Qual é o grau de segurança?',
        },
        title: 'Perguntas frequentes',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Publicidades (e arte)',
            custom: 'Carrega a tua própria',
            feature_1: 'Página WeTransfer personalizada',
            feature_2: 'Fundos de ecrã',
            feature_3: 'E-mails personalizados no WeTransfer',
          },
          title: 'Mostra a tua marca',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} de armazenamento',
            title: 'Collect do WeTransfer',
          },
          paste: {
            limited_decks:
              'Até %{pasteDecksLimit} apresentações com o logótipo padrão do Paste',
            title: 'Paste® do WeTransfer',
            unlimited_decks: 'Apresentações ilimitadas com a tua marca',
          },
          title: 'Completa as tuas ferramentas criativas',
        },
        expiry: 'As transferências expiram após %{days} dias',
        extra_storage: '%{storageLimit} adicionais por pessoa',
        monthly_price: '%{price} mensalmente por pessoa',
        portals: {
          features: {
            feature_1: 'Portais',
            feature_2: 'Revisões',
            feature_3: 'Marca do cliente',
          },
          title: 'Partilha trabalho para feedback e aprovação',
        },
        security: {
          features: {
            feature_1: 'Datas de expiração personalizadas',
            feature_2: 'Transferências protegidas por palavra-passe',
            feature_3: 'Encriptação de dados',
            feature_4: 'Autenticação em duas etapas',
          },
          title: 'Protege as tuas transferências',
        },
        storage_limit: '%{storageLimit} por pessoa',
        teams: {
          features: {
            feature_1: 'Convida membros para a equipa',
            feature_2: 'Resumo de transferências partilhadas',
            feature_3: 'Armazenamento partilhado',
            feature_4: 'Marca partilhada',
          },
          title: 'Entrega trabalho como uma equipa',
          subtext: {
            text: 'Apenas suportado se adquirires uma assinatura a partir do nosso website.',
            learn_more: 'Saiba mais',
          },
        },
        tooltips: {
          tooltip_1:
            'Todas as transferências que envias contam como armazenamento',
          tooltip_10:
            'Podes enviar e armazenar ficheiros de forma segura com encriptação TLS e AES-256',
          tooltip_11:
            'Rastreia os descarregamentos e gere transferências em conjunto',
          tooltip_12:
            'Mostra o teu trabalho (de equipa) com fundos de ecrã e e-mails da marca',
          tooltip_13:
            'O Paste é uma ferramenta de apresentação para design de apresentações com cores, alinhamento e lay-out dinâmicos',
          tooltip_14:
            'O Collect permite-te guardar e organizar imagens, vídeos, música e links através de dispositivos',
          tooltip_2:
            'Os destinatários podem descarregar os teus ficheiros sem fazer login ou registar',
          tooltip_3: 'Vê quem descarregou os teus ficheiros (e quem não o fez)',
          tooltip_4: 'Organiza o teu trabalho por cliente e por projeto',
          tooltip_5:
            'Convida os clientes para visualizar e selecionar ficheiros, adicionar comentários e fornecer aprovação - sem ter de descarregar nada',
          tooltip_6:
            'Adicionar um logótipo para personalizar os teus portais para cada cliente',
          tooltip_7:
            'A tua página no WeTransfer é o sítio onde as pessoas descarregam os teus ficheiros e podem enviar as tuas transferências com o limite de tamanho do teu plano',
          tooltip_8:
            'Os fundos de ecrã são os vídeos e imagens que vês no fundo quando estás a enviar e receber ficheiros no wetransfer.com',
          tooltip_9:
            'Uau, pensávamos que ninguém lia isto - afinal, parece que sim. Ainda bem! As capturas de ecrã poderão ser republicadas pelo @WeTransfer no twitter',
        },
        transfer_classic: {
          features: {
            feature_1: 'Limite de tamanho de transferência',
            feature_2: 'Armazenamento',
            feature_3: 'Descarregamentos sem conta',
            feature_4: 'Rastrear descarregamentos',
            feature_5: 'Aplicação iOS',
          },
          title: 'Enviar grandes ficheiros',
        },
        unlimited: 'Sem limites',
        yearly_price: '%{price} anualmente por pessoa',
      },
      header: {
        subtitle:
          'Quer estejas a enviar grandes ficheiros por prazer ou a entregar trabalhos a clientes - mantém os teus projetos criativos em movimento com o WeTransfer.',
        title: {
          english_1: 'Tu tens as ideias,',
          english_2: 'nós temos os planos',
          general: 'Planos e preços',
        },
      },
      plans: {
        billing: {
          discount: 'Poupa %{percentage} (boa, não é?)',
          monthly: 'Faturação mensal',
          yearly: 'Faturação anual',
        },
        free: {
          subtitle: 'Envia ficheiros ocasionalmente',
          title: 'Gratuito',
          usp: {
            feature_1: 'Envia até %{transferLimit}',
            feature_2: 'Não é necessário verificar transferências',
          },
        },
        premium: {
          subtitle: 'Partilha trabalho sem limites',
          title: 'Premium',
          usp: {
            feature_1: 'Sem limite de tamanho das transferências',
            feature_2: 'Armazenamento ilimitado',
            feature_2_subtitle:
              '*O limite inicial é %{storageLimit}, com a opção de adicionar armazenamento extra a pedido. Aplica-se um limite máximo anual de %{annualStorageLimit}. Consulte os nossos <a href="/legal/terms" data-route-type="premium" target="_blank">Termos de Serviço</a> para obter mais informações.',
            feature_3: 'Portais e revisões ilimitadas',
          },
        },
        pro: {
          subtitle: 'Envia ficheiros mesmo grandes regularmente',
          title: 'Pro',
          usp: {
            feature_1: 'Envia e recebe até %{transferLimit}',
            feature_2: '%{storageLimit} de armazenamento por pessoa',
            feature_3: '%{portalsLimit} no portal, revisões ilimitadas',
          },
        },
        tagline: {
          free: 'não tens dinheiro? não há problema',
          monthly: 'preço mensal por utilizador',
          yearly: 'preço anual por utilizador',
          per_person_monthly: 'por pessoa, faturação mensal',
          per_person_yearly: 'por pessoa, faturação anual',
          tax_included: 'imposto incluído',
        },
        title: 'Escolhe o teu plano',
        month: 'mês',
      },
      skip_link: 'Passar a mais funcionalidades',
    },
    pro_classic: {
      hero: {
        cta_1: 'Ver mais',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Tu tens as ideias, nós temos os planos',
      },
      cta: 'Só desejo enviar ficheiros',
      free_panel: {
        cta: 'Inscrever',
      },
      plan: {
        free: {
          feature_1: 'Envia até <strong>%{transfer_limit}</strong>',
          feature_2: 'Não é necessário verificar transferências',
          subtitle_new: 'Para remetentes ocasionais',
          title: 'Gratuito',
        },
        pro: {
          feature_1: 'Envia e recebe até <strong>%{transfer_limit}</strong>',
          feature_2: 'Decide quando as tuas transferências expiram',
          feature_5: '1 TB de armazenamento por pessoa',
          subtitle_new: 'Para profissionais e equipas',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Inscreve-te já',
          descripttion: 'Acompanha as transferências',
          feature_1: 'Envia até 2 GB',
          feature_2: 'Recebe transferências com um só resumo',
          title: 'Gratuito',
        },
        pro: {
          cta: 'Saber mais',
          descripttion: 'Aproveita o melhor do WeTransfer',
          feature_1: 'Envia e recebe até %{transfer_size}',
          feature_2:
            '%{storage_size} de armazenamento de transferências por pessoa',
          feature_3: 'Envia transferências com definições personalizadas',
          title: 'Pro',
        },
        title:
          'Não deixes que as transferências se percam na tua caixa de entrada.',
      },
      title: 'Desfruta ao máximo do novo WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Convidar equipa',
        pagename: 'Convidar a equipa',
      },
      manage: {
        cta: 'Gerir equipa',
      },
      members:
        'Tens %{amountOfMembers} membros na tua equipa. <a href="%{href}">%{cta}</a>',
      no_members: 'Por enquanto, és só tu! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Configurações de equipa',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Cria uma equipa e transfere em conjunto',
        context:
          'Envia e recebe transferências como equipa com armazenamento partilhado, branding e acesso às transferências de todos os membros da equipa.',
        invite_team: 'Convidar equipa',
        dismiss: 'Talvez mais tarde',
      },
      feature_highlight: {
        free_context:
          'Agora, podes gerir as transferências enviadas e recebidas com um simples resumo. Fica a saber quando os teus ficheiros são descarregados. Reenvia, reencaminha ou descarrega as tuas transferências com um clique. É assim tão fácil',
        free_subtitle: 'Todas as tuas transferências, num único lugar.',
        paste_collect_link:
          'Vai para <a href="%{pasteUrl}" rel="external">%{pasteName}</a> ou <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Agora, podes enviar transferências de qualquer tamanho, e criar a tua própria <b>página no WeTransfer</b>, para personalizar o que as pessoas vêm ao descarregar os teus ficheiros. Estás pronto para escolher o teu URL e fundos de ecrã?',
        premium_cta: 'Criar página',
        premium_dismiss: 'Talvez mais tarde',
        premium_subtitle: 'Configura a tua página no WeTransfer',
        premium_team_context:
          'Agora, podes enviar e receber transferências de qualquer tamanho a partir da página personalizada da tua equipa no WeTransfer.',
        pro_context:
          'Agora, podes enviar até %{transfer_limit} de uma só vez, e criar a tua própria <b>página no WeTransfer</b> para personalizar o que as pessoas vêm quando descarregam os teus ficheiros. Estás pronto para escolher o teu endereço URL e fundos de ecrã?',
        pro_team_context:
          'Agora, podes enviar e receber %{transfer_limit} transferências da <b>página personalizada do WeTransfer</b> da tua equipa.',
        send_cta: 'Ir para enviar ficheiros',
        team_subtitle: 'Entrega o trabalho criativo como equipa',
      },
      marketing: {
        context:
          'Agora que já sabemos um pouco mais acerca de ti, adoraríamos contar-te mais sobre nós. Queres ficar a par de histórias criativas e das últimas novidades do WeTransfer?',
        image_alt_text:
          'Exemplo de conteúdo de e-mail, inclusive novas funções de produtos, relatórios da indústria e artigos no WePresent que contam histórias criativas.',
        opt_in: 'Sim, por favor',
        opt_out: 'Não, obrigado',
        unsubscribe:
          'Podes sempre anular a inscrição mais tarde - não te levamos a mal.',
      },
      welcome: {
        context:
          'Ficar a conhecer-te melhor permite-nos melhorar o nosso serviço.',
        cta: 'Continuar',
        dismiss: 'Saltar',
        dropdown_options: {
          architecture: 'Arquitetura / Construção',
          data: 'Data / Finanças / Legal',
          design: 'Design / Ilustração',
          education: 'Educação / Formação',
          marketing: 'Marketing / RP',
          music: 'Música / Som',
          other: 'Outros (e com orgulho)',
          photography: 'Fotografia',
          product: 'Produto / Software',
          sales: 'Vendas / Relações com clientes',
          video: 'Vídeo / Animação',
        },
        free_tier_title: 'Bem-vindo ao WeTransfer, %{name}!',
        placeholder: 'Hum, vamos ver...',
        question: 'Em primeiro lugar, em que sector trabalhas?',
        team_title: 'Chegaste à equipa, %{name}!',
        tier_title: 'Bem-vindo ao WeTransfer %{tier}, %{name}!',
        data_opt_in: {
          checkbox_label:
            'Permite que o WeTransfer utilize dados para te apresentar anúncios personalizados dentro e fora dos nossos Websites.',
          tooltip_anchor: 'O que significa isto?',
          tooltip: {
            title: 'Como é que o WeTransfer utiliza os meus dados?',
            p1: 'Utilizamos o teu endereço de e-mail para te apresentar (e a outras pessoas como tu) anúncios do WeTransfer em Websites que visitas, como as redes sociais.',
            p2: 'Também utilizamos a tua área de trabalho para te proporcionar uma melhor experiência nos nossos Websites.',
            p3: 'Os dados que optares por partilhar connosco estarão sempre seguros.',
            button: 'Entendido',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Adicione outras pessoas ao seu espaço de trabalho',
      workspace: 'Espaço de trabalho',
      manage_workspace: 'Gerir espaço de trabalho',
    },
  },
  exception: {
    activate_subscription_exception:
      'Hmm, algo correu mal - tenta novamente ou contacta-nos através do nosso <a href="https://wetransfer.zendesk.com" rel="external">centro de ajuda</a>',
    complete_payment_exception:
      'Hmm, algo correu mal - tenta novamente ou contacta-nos através do nosso <a href="https://wetransfer.zendesk.com" rel="external">centro de suporte</a>',
    retrieve_checkout_exception:
      'Hmm, algo correu mal - tenta novamente ou contacta-nos através do nosso <a href="https://wetransfer.zendesk.com" rel="external">centro de ajuda</a>',
    source_id_error:
      'Desculpa, não foi possível processar este pedido — tenta novamente',
    three_d_secure: 'Atualmente não suportamos cartões de seguros 3D.',
    something_went_wrong:
      'Ocorreu um problema - tenta novamente ou contacta-nos através do nosso <a href="https://wetransfer.zendesk.com" rel="external">centro de ajuda</a>',
    signin_no_data_exception:
      'Ocorreu um problema - verifica o teu nome de utilizador e a tua palavra-passe, e tenta novamente',
    signin_exception:
      'Infelizmente, não foi possível iniciar sessão – tenta novamente',
    signout_exception:
      'Parece que não foi possível terminar sessão. Que estranho. Atualiza esta página para verificar se ainda tens sessão iniciada.',
    signup_account_error:
      'Hmm, ocorreu um problema durante o início de sessão – verifica os teus detalhes e tenta novamente',
    retrieve_account_exception:
      'Ocorreu um problema. Lamentamos, mas podes tentar novamente?',
    update_account_error:
      'Pedimos desculpa mas não foi possível atualizar os detalhes da tua conta. Podes tentar novamente?',
    retrieve_subscription_exception:
      'Não foi possível localizar os teus detalhes de pagamento - tenta novamente',
    update_subscription_exception:
      'Não foi possível localizar os teus detalhes de pagamento - tenta novamente ou contacta-nos através do nosso <a href="https://wetransfer.zendesk.com" rel="external">centro de ajuda</a>',
    autorenewal_not_supported:
      'Esta conta não suporta a opção de renovação automática',
    email_background_upload_validation_error:
      'Este ficheiro é demasiado grande, ou não está em formato png ou jpg; tenta uma imagem diferente',
    email_background_upload_validation_error_videos:
      'Este ficheiro é demasiado grande, ou não está em formato png ou jpg; tenta uma imagem diferente',
    update_password_exception:
      'Pedimos desculpa mas não foi possível atualizar a tua palavra-passe – tenta novamente',
    retrieve_device_exception:
      'Não foi possível localizar dispositivos ligados. Tenta novamente.',
    remove_device_exception: 'Não foi possível remover este dispositivo',
    renew_subscription_exception:
      'Não é possível renovar a tua conta agora – tenta novamente mais tarde',
    invoices_retrieve_exception:
      'Não foi possível localizar os teus recibos – tenta novamente',
    invoice_download_exception:
      'Não foi possível fazer download deste recibo – tenta novamente',
    image_not_valid: 'Parece que não é possível carregar esta imagem',
    update_profile_error:
      'Não é possível atualizar o teu perfil – tenta mais tarde',
    retrieve_profile_exception:
      'Não foi possível localizar as definições do teu perfil – tenta novamente',
    s3_exception:
      'Ocorreu um problema durante o carregamento – tenta novamente',
    file_size_limit_reached:
      'O ficheiro é demasiado grande – carrega uma imagem com 3 MB ou inferior',
    retrieve_transferlist_exception:
      'Não foi possível localizar a tua lista de transferências',
    retrieve_transfer_exception:
      'Não foi possível localizar os detalhes da transferência',
    delete_transfer_exception: 'Não foi possível eliminar esta transferência',
    delete_transfers_exception:
      'Não foi possível eliminar estas transferências',
    update_expiry_exception:
      'Não foi possível atualizar esta data de expiração',
    add_contact_exception: 'Não foi possível adicionar este contacto',
    complete_last_order_exception: 'Não foi possível concluir a tua encomenda',
    edit_contact_exception: 'Não foi possível atualizar este contacto',
    remove_contact_exception: 'Não foi possível eliminar este contacto',
    request_password_reset_exception:
      'Infelizmente, não foi possível processar este pedido de redefinição — tenta novamente',
    request_password_reset_no_user:
      'Este endereço de e-mail não é reconhecido - verifica outra vez e tenta novamente',
    reset_password_error:
      'Ocorreu um problema durante a redefinição da tua palavra-passe — tenta novamente',
    reset_password_exception:
      'Infelizmente, não é possível redefinir a tua palavra-passe neste momento — tenta novamente',
    reset_password_token_invalid:
      'Este link de redefinição não funcionou — segue as instruções que te enviámos por e-mail, ou começa novamente',
    retrieve_last_order_exception: 'Não foi possível localizar a tua encomenda',
    retrieve_ternot_exception:
      'Hmm, não conseguimos localizar a tua transferência - tenta novamente',
    signin_invalid_credentials:
      'Parece que este endereço de e-mail e esta palavra-passe não correspondem — verifica outra vez e tenta novamente',
    unsubscribe_expiration_exception:
      'Ocorreu um problema ao anular a tua subscrição - tenta novamente',
    unsubscribe_expiration_invalid_signature:
      'Este link para anular a subscrição não funcionou - tenta novamente',
    cancel_subscription_exception:
      'Pelo que parece, houve um erro. Não pudemos cancelar a sua assinatura. Tente novamente mais tarde.',
    payment_cancelled:
      'Hmm, algo correu mal - tenta novamente ou contacta-nos através do nosso <a href="https://wetransfer.zendesk.com" rel="external">centro de ajuda</a>',
    profile_picture_upload_validation_error:
      'Este ficheiro é demasiado grande, ou não está em formato png ou jpg; tenta uma imagem diferente',
    reactivate_subscription_exception:
      'Ocorreu um erro, por favor, tenta novamente',
    retrieve_contactlist_exception:
      'Não foi possível localizar a tua lista de contactos',
    source_retrieve_error:
      'Hmm, algo correu mal - tenta novamente ou contacta-nos através do nosso <a href="https://wetransfer.zendesk.com" rel="external">centro de ajuda</a>',
    token_error: 'Algo correu mal. Quer voltar a tentar?',
    update_user_error: 'Houve um problema na atualização da tua informação',
    wallpaper_upload_validation_error:
      'Este ficheiro é demasiado grande, ou não está em formato png ou jpg; tenta uma imagem diferente',
    wallpaper_upload_validation_error_videos:
      'Ups, parece que o teu vídeo não corresponde aos nossos requisitos - tenta novamente',
    declined_contact_bank_error:
      'Pedimos desculpa, não foi possível processar este pagamento - por favor contacte o seu banco',
    invalid_password: 'Palavra-passe não reconhecida',
    otp_token_invalid: 'Ups, esse código está errado ou já não é válido.',
    projects_load_exception:
      'Não estamos a conseguir carregar os teus projetos',
    update_information_throttle:
      'Houve um problema na atualização da tua informação. Faz uma pausa de %{throttle_time} antes de tentares novamente.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Produtos',
        plans_and_pricing: 'Planos e preços',
        pricing: 'Tarifas',
        pro_and_premium: 'WeTransfer Pro e Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Anunciar',
        upgrade: 'Mudar de plano',
      },
      name_1_2019: 'Empresa',
      name: 'Empresa',
    },
    home: {
      name: 'Página principal',
    },
    help: {
      name: 'Ajuda',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Transferências',
        contacts: 'Contactos',
        profile: 'Profile',
        account: 'Conta',
        received: 'Recebidas',
        sent: 'Enviadas',
        teams: 'Equipa',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Terminar sessão',
    signin: {
      name: 'Iniciar sessão',
    },
    branding: 'Desenvolvimento de marca',
    label: {
      beta: 'Beta',
      new: 'Novidades',
    },
    login: 'Aceder',
    logout: 'Sair',
    portals: 'Portais',
    signup: 'Inscreve-te',
    features: {
      name: 'Funcionalidades',
      all: 'Todas as funcionalidades',
      file_sharing: 'Para partilha de ficheiros',
      collaboration: 'Para colaboração',
      security: 'Para segurança dos dados',
      branding: 'Para branding',
      fast_feedback: 'Para um feedback rápido',
    },
    referral: 'Recomenda amigos',
    switcher: {
      create_free_account: 'Adicionar gratuitamente',
      just_you: 'Apenas tu',
      team: 'Equipa',
      team_member_count: '%{amountOfMembers} membros',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Hmm, não estás ligado à Internet',
        begins_space:
          'Não é possível enviar ficheiros cujos nomes começam com um espaço. Muda o nome e tenta novamente.',
        begins_stop:
          'Não é possível enviar ficheiros cujos nomes começam com um ponto final. Muda o nome e tenta novamente.',
        blocked:
          'Não foi possível carregar o WeTransfer – parece que estás bloqueado',
        generic: 'Infelizmente ocorreu um problema durante a tua transferência',
        has_blackslash:
          'Não é possível enviar ficheiros cujos nomes começam com uma barra invertida. Muda o nome e tenta novamente.',
        has_linebreak:
          'Não é possível enviar ficheiros cujos nomes incluem uma quebra de linha. Muda o nome e tenta novamente.',
        incorrect_recipient:
          'Parece que um dos endereços de e-mail que introduziste está incorreto',
        incorrect_sender:
          'Parece que há um problema com o teu endereço de e-mail',
        io_error: 'Há um problema com os teus ficheiros',
        long_filename:
          'Não é possível enviar ficheiros cujos nomes têm mais de 250 caracteres. Muda o nome e tenta novamente.',
        long_message: 'Essa mensagem é demasiado longa – encurta-a',
        missing_default_recipient:
          'Só podes enviar mais de %{free_transfer_limit} para o endereço de e-mail WeTransfer Pro inscrever. Atualiza a página para começar novamente.',
        no_clipboard: 'Parece que não copiaste o link',
        no_files: 'Parece que ainda não adicionaste ficheiros!',
        no_folders: 'Tens de zipar/comprimir a pasta para podermos enviá-la',
        no_recipient:
          'Precisamos do endereço de e-mail para onde pretendes enviar estes ficheiros',
        no_sender:
          'Agora já só falta o teu endereço de e-mail para podermos continuar',
        too_big:
          'Espera lá – não é possível transferir mais de %{upload_limit} de uma vez',
        too_many_recipient:
          'Ups! - O nosso limite são %{count} pessoas. Necessitas de mais? Utiliza um link para transferência.',
        unavailable:
          'Infelizmente, esta transferência foi eliminada e já não está disponível',
        wrong_password:
          'Hmmm, essa palavra-passe não está correta. Tenta novamente ou confirma com a pessoa que te enviou esta transferência.',
        default_title: 'Ups!',
        duplicate_filename:
          'Não é possível enviar vários ficheiros com o mesmo nome. Muda o nome e tenta novamente.',
        firstaccept: 'Necessita de aprovar primeiro, antes de enviar',
        not_downloadable:
          'Ocorreu um problema ao tentar obter os teus ficheiros. Recarrega a página e tenta novamente.',
        recaptcha: {
          text: 'Algo correu mal. Por favor, tenta novamente!',
          title: 'Ups...',
        },
        too_big_text:
          'Não podes efetuar transferências superiores a %{upload_limit} ao mesmo tempo. Com o Pro, podes enviar até %{plus_limit}. ',
        too_big_title: 'Olá big sender',
        too_many_files:
          'Não é possível enviar %{count} ficheiros ao mesmo tempo',
        too_many_recipient_text:
          'Você pode transferir ficheiros para 50 pessoas com o Pro.',
        too_many_recipient_title: 'Selecionaste demasiadas pessoas',
        unavailable_forward:
          'Infelizmente, parece que esta transferência foi eliminada, por isso não pode ser reencaminhada',
        verify: {
          button: 'Envie-me um novo código!',
          text: 'Tente novamente ou peça um novo código. ',
          title: 'Ups!',
        },
      },
      buttons: {
        check_out: 'Vem ver!',
        help: 'Centro de ajuda',
        plus: 'Obtém o Pro',
        get_link: 'Obter link',
      },
      tips: {
        change_type:
          'Enviar ficheiros por e-mail, ou gerar um link de transferência próprio que podes partilhar como preferires',
        contacts:
          'As pessoas a quem enviares ficheiros serão adicionadas automaticamente aos teus contactos',
        expiry:
          'Com o WeTransfer Pro, tu decides quando as tuas transferências expiram. (Até podes alterar a data de expiração após enviares a transferência!)',
        free_limit:
          'Boas notícias, podes enviar até %{size} de uma vez. Melhor ainda, podes usar o serviço as vezes que quiseres.',
        message:
          'Se quiseres, podes escrever aqui uma mensagem para acompanhar a tua transferência',
        password:
          'Para uma maior segurança, podes proteger a transferência com uma palavra-passe. Tem em atenção que não iremos adicionar a palavra-passe ao e-mail, por isso terás de ser tu a fornecê-la às pessoas certas.',
        recipient_limit:
          'Adiciona até %{email_limit} e-mails ou abre o menu ao lado do botão de transferência para criar um link',
        transfer_history:
          'A tua transferência fica armazenada na lista de transferências',
        your_email:
          'Deixa aqui o teu endereço de e-mail para te podermos notificar quando o download dos teus ficheiros tiver sido feito',
        link_transfer:
          'Sabias que podes encontrar o teu link para transferência aqui?',
        previews_receiver:
          'As imagens enviadas pelos utilizadores Pro podem ser pré-visualizadas antes de serem descarregadas.\nBasta clicar num ficheiro para ver o conteúdo!',
        previews_sender:
          'As imagens que enviar podem ser pré-visualizadas antes de serem descarregadas',
        vrl_text:
          'Agora, é possível visualizar os seus ficheiros sem ter de os descarregar.',
        vrl_title: 'Visualizar ficheiros',
        zip_text: 'Queres enviar um arquivo? Nós comprimimo-lo para ti',
        zip_title: 'Não é preciso comprimir',
        add_display_name_tooltip:
          'Dá um título à tua transferência para que as pessoas saibam do que se trata. Isto também facilita a procura mais tarde.',
        anonymous_sender: {
          button: 'Obtém um link',
          text: 'Insere o teu endereço de e-mail, para te podermos informar quando os teus ficheiros forem descarregados.\n\nNecessitas de verificar primeiro o teu e-mail para sabermos que és tu. Não queres verificá-lo a cada transferência?',
          text_locked_recipient:
            'Insere aqui o teu endereço de e-mail, para que possamos informar-te quando os teus ficheiros tiverem sido descarregados.\n\nNecessitas de verificar primeiro o teu e-mail para sabermos que és mesmo tu.',
        },
        prefer_link: {
          button: 'Obtém um link',
          text: 'Não queres verificar o teu e-mail? Não há problema.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Saiba mais',
        previews_sender_learnmore: 'Saiba mais',
      },
      recipient_locked_text:
        'Esta página serve para o proprietário receber ficheiros. Acede se fores tu o proprietário, ou visita <a href="https://wetransfer.com">wetransfer.com</a> para enviar para outra pessoa.',
      recipient_locked_title: 'Atenção',
      title: {
        previews_receiver: 'Pré-visões de imagens',
        previews_sender: 'Pré-visões de imagens',
      },
    },
    download: {
      blocked: {
        link: 'Descobre mais',
        text: 'Esta transferência foi reportada e não pode ser descarregada',
        title: 'Bloqueio transferência',
      },
      title: 'Estamos prontos',
      expires: 'A transferência expira em %{relative_time}',
      expires_never: 'Sem data de expiração',
      files: '%{count} ficheiros, %{size}',
      format: '%{files}・%{expires}',
      expand: 'mais',
      download_link: 'Link para download',
      files_nosize: {
        one: '%{count} ficheiro',
        other: '%{count} ficheiros',
      },
      show_all_files_mobile: 'Mostrar todos os ficheiros',
      zip_information:
        'Vais receber um ficheiro .zip quando fizeres o download de todos os ficheiros de uma vez só - <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">ler mais</a>',
      files_label: 'Ficheiros',
      message: 'Mensagem',
      learn_more: 'sabe mais',
      expires_in: 'Expira dentro de %{expiry}',
      download_all_zip:
        'Transferir tudo irá transferir todos os ficheiros como um .zip',
      back_to_transfer: 'Regressar à transferência',
      cookie_text:
        'Utilizamos cookies para te proporcionar a melhor experiência. Não tenhas medo, não vendemos os teus dados a terceiros. Gere as tuas <a href="https://wetransfer.com/legal/manage-cookies" rel="external">preferências de dados</a>.',
    },
    preview: {
      open_grid: 'Pré-visualizar',
      click_to_open: 'Clique para pré-visualizar',
      grid: 'Elementos nesta transferência',
      link: 'Site internet',
      not_previewable: 'Vista indisponível',
      now_open: 'Abrir visualização',
      open_link: 'Abrir hiperligação num novo separador',
      open_link_short: 'Abrir link',
      overview: 'vista geral',
      reload: 'Clique aqui para voltar a carregar',
      something_went_wrong: 'Ups, ocorreu um problema',
      tap_to_open: 'Pré-visualizar',
      toobig_copy:
        'Apenas podemos pré-visualizar imagens até 50MB – <a href="https://wetransfer.zendesk.com/" rel="external">ler mais aqui</a>',
      toobig_title:
        'Uf – esta imagem é demasiado grande para ser pré-visualizada',
      unsupported_copy:
        'Veja <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">este artigo</a> para descobrir que ficheiros se podem pré-visualizar',
      unsupported_title: '(Ainda) impossível ver este ficheiro',
      visit_website: 'Visitar o site internet',
    },
    complete_mobile: {
      email_text:
        'O e-mail de transferência foi enviado – a tua transferência está disponível durante %{expires}.',
      link_text: 'Copia o link para download:',
      email_text_no_expiry: 'O e-mail foi enviado para o recipiente.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>Sabias que 30% do nosso espaço publicitário está reservado aos artistas?</b> Ao aceitares os nossos cookies, estarás a permitir-nos mostrar-te um pouco de arte, algumas causas que são importantes para nós, e algumas publicidades premiadas que não incomodam ninguém. ',
          text: 'Também aceitas os cookies de terceiros, os nossos parceiros publicitários, para podermos personalizar as publicidades que vês? ',
          title: 'Os nossos cookies alimentam a cultura',
        },
        subtitle:
          '<b>É por isso que 30% do nosso espaço publicitário está reservado aos artistas.</b> Ao aceitares os nossos cookies, estarás a permitir-nos mostrar-te um pouco de arte, algumas causas que são importantes para nós, e algumas publicidades premiadas que não incomodam ninguém. ',
        text: 'O nosso site utiliza cookies que o ajudam a funcionar devidamente, nos permitem compreender como utilizas o WeTransfer, e nos ajudam a melhorar o desempenho. Também aceitas os cookies de terceiros, os nossos parceiros publicitários, para podermos personalizar as publicidades que vês?',
        title: 'Nós acreditamos que a arte pode mover montanhas',
        'title-small': 'Bem-vindo ao WeTransfer',
      },
      'button-accept': 'Aceito',
      'button-accept-all': 'Aceitar todos',
      'button-ccpa': 'Opta pela venda de informações pessoais',
      'button-cookies-privacy': 'As tuas escolhas de privacidade',
      'button-reject': 'Não, obrigado',
      'button-save': 'Guardar',
      'button-save-and-exit': 'Guardar e fechar',
      'ccpa-banner-text':
        'Utilizamos cookies para garantir que tens a melhor experiência no nosso website. Não tenhas medo, não vendemos os teus dados a terceiros. Optar por sair de qualquer maneira? <a href="%{href}">Gerir configurações</a>',
      'ccpa-body':
        'Porque estás nos EUA, os teus direitos são protegidos pela Lei de Privacidade do Consumidor da Califórnia (CCPA) e podes pedir-nos que deixemos de vender as tuas informações pessoais. Isto não significa que leiloemos os teus dados pessoais ou ficheiros privados ao licitador com a maior oferta - nunca o fizemos e nunca o faremos! Fazemos grandes esforços para manter a tua pegada digital pequena, segura e sob o teu controlo. Podes ler mais sobre quais dados recolhemos e porquê em <a href="%{href}">As tuas opções de privacidade</a>.',
      'ccpa-donotsell': 'Não vender as minhas informações pessoais',
      'ccpa-header': 'Optar pela venda de informações pessoais',
      'ccpa-intro':
        'Como empresa tecnológica responsável empenhada numa Internet melhor, não vendemos os teus dados a terceiros. Mas, de qualquer forma, tens o direito de optar oficialmente pela não participação.',
      'ccpa-variant-test-text':
        'Usamos cookies para garantirmos que tens uma experiência impecável no nosso website, e para personalizar as publicidades que vês. <a href="%{href}">Gestão de cookies</a>',
      headline: 'Cookies e publicidade',
      intro:
        'O dinheiro que ganhamos com as nossas bonitas publicidades ajuda-nos a pagar as contas. É assim que conseguimos proporcionar-te este serviço de partilha de ficheiros gratuitamente.',
      'manage-cookies': 'Gestão de cookies',
      'partners-consent': 'Autorização',
      'partners-features': 'Funções',
      'partners-headline': 'Os nossos parceiros',
      'partners-text':
        '<p>Aqui encontrarás uma lista alfabética dos parceiros cuidadosamente selecionados que têm acesso aos teus dados, para podermos rastrear e melhorar o desempenho.</p>',
      'preferences-headline': 'Gestão de cookies ',
      'preferences-text':
        '<p>Respeitamos o teu direito à privacidade e as tuas escolhas relativamente aos teus dados. Necessitamos de processar alguns dos teus dados pessoais enquanto utilizas as nossas ferramentas mas comprometemo-nos a assumir uma abordagem responsável e guiada pelos valores, tanto nos negócios, tecnologia, como na relação que temos contigo.</p> \n<p>É por isso que colocamos imenso esforço para manter a tua pegada digital pequena, segura, e controlada por ti.</p> \n<p>Regra geral, só recolhemos e processamos dados quando é mesmo necessário. No entanto, se desejares apoiar o nosso serviço e ajudar a manter o WeTransfer gratuito, por favor permite-nos partilhar dados com os nossos parceiros publicitários.</p>',
      'preferences-text-allow-cookies':
        'Autoriza os cookies, para que nós e/ou os nossos parceiros possamos:<br><br>',
      'purpose-description-first-intro':
        'Para promover produtos em e fora do nosso site e aplicações, o WeTransfer pode: ',
      'purpose-description-first-list':
        '<ul><li>Recolher dados sobre como interages com o(s) nosso(s) site(s), como os cliques e as páginas visitadas, e (quando possível) combinar estas informações com dados que tenhamos armazenados sobre ti, como o endereço de e-mail da tua conta. </li><li>Utilizar a informação que recolhemos para te fornecermos ofertas e promoções por e-mail, ou no(s) nosso(s) próprio(s) site(s) ou aplicações; e nos sites ou aplicações de terceiros. Por exemplo, poderemos promover um dos nossos outros produtos quando utilizares o WeTransfer Pro.</li></ul>',
      'purpose-description-second-intro':
        'Para promover produtos em e fora do nosso site ou aplicações, os nossos parceiros podem: ',
      'purpose-description-second-list':
        '<ul><li>Recolher dados sobre como interages com o(s) nosso(s) site(s), como os cliques e as páginas visitadas, e (quando possível) combinar estas informações com dados que tenhamos armazenados sobre ti</li><li>Utilizar a informação que recolhemos para te fornecermos ofertas e promoções por e-mail, ou no(s) seu(s) próprio(s) site(s) ou aplicações; e nos sites ou aplicações de terceiros com quem colaborem.</li></ul>',
      'purpose-title':
        'Promoção de produtos em e fora do nosso site e aplicações',
      'switch-by-partners': 'Pelos parceiros',
      'switch-by-we-transfer': 'Pelo WeTransfer',
      text: '<p>O nosso site usa <a href="%{href}">cookies</a> que te ajudam a funcionar, que nos permitem analisar a forma como interages com o mesmo, e que nos ajudam a melhorar o nosso desempenho.</p> \n<p>Também desejas aceitar cookies dos nossos parceiros publicitários para podermos personalizar os anúncios que vês, bem como promover os produtos do WeTransfer e dos nossos parceiros tanto nos nossos sites e aplicações como noutras plataformas?</p>',
      'text-panel':
        '<p>O nosso site usa cookies que te ajudam a funcionar, que nos permitem analisar a forma como interages com o mesmo, e que nos ajudam a melhorar o nosso desempenho.</p> \n<p>Também desejas aceitar cookies dos nossos parceiros publicitários para podermos personalizar os anúncios que vês, bem como promover os produtos do WeTransfer e dos nossos parceiros tanto nos nossos sites e aplicações como noutras plataformas?</p>',
      'tos-experiment': {
        'cookie-intro':
          'A forma mais fácil de enviar ficheiros de grandes dimensões, descobrindo ao mesmo tempo fantástica arte e publicidades galardoadas com prémios.',
        'cookie-text':
          'O nosso site utiliza cookies que o ajudam a funcionar, nos permitem analisar a sua interação com o mesmo, e nos ajudam a melhorar o desempenho.\nAo aceitar os nossos cookies, estará a permitir-nos mostrar-lhe publicidades personalizadas. Já dissemos cookies vezes suficientes? (Cookie.)',
      },
      trees: {
        'short-v': {
          subtitle:
            'A nossa missão é embelezar o mundo com publicidades galardoadas com prémios, que não incomodam ninguém, e nos ajudam a contribuir para a restauração de florestas marítimas.',
          title: 'Os nossos cookies protegem o planeta',
        },
        subtitle:
          'Ao aceitares os nossos cookies, estás a ajudar-nos diretamente a cumprir a nossa promessa para o planeta. Só este ano, o WeTransfer comprometeu-se a plantar mais de 175 000 árvores, e estamos apenas no início. Irás ter um impacto positivo para o planeta só através das nossas publicidades premiadas. ',
        text: 'O nosso site utiliza cookies que nos ajudam a melhorar o desempenho, serviço, e a melhor compreender as tuas necessidades. Ao aceitares os nossos cookies de terceiros, tanto nós como os nossos parceiros publicitários seremos capazes de oferecer-te publicidades mais relevantes, dentro e fora do(s) nosso(s) site(s) e aplicações.',
        title: 'Transfere ideias. <b>Transforma o mundo.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Descobre o Collect Pro',
      title: 'Guarda e partilha inspiração em movimento',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Digam-me mais',
      title: 'Paste® Pro e Collect Pro agora incluídos na sua assinatura',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Obtém o Paste® Pro',
      title: 'Torna as grandes ideias em bonitos painéis de apresentação',
    },
    terms_conditions: {
      experiment: {
        text: 'Para continuar, por favor aceite os nossos <a href="/legal/terms" data-route-type="plus">Termos e Condições</a>.',
        title: "Estás <span class='tc-title-exp'>quase</span> lá",
        ustitle:
          "Bem-vindo ao caminho mais simples para <span class='tc-title-exp'>enviar grandes ficheiros.</span>",
      },
      title: 'Para começar...',
      text: 'Aceite os nossos <a href="/legal/terms" data-route-type="plus">Termos de Serviço</a> e <a href="/legal/privacy" data-route-type="plus">Política de cookies</a>. Usamos cookies funcionais e analíticos e cookies de terceiros para publicidade.',
      language: 'Idioma definido para',
      button: 'Concordo',
    },
    upsell_pricing: {
      text: 'Comparar planos',
      title: 'Queres enviar transferências maiores?',
      receiving: {
        title: 'Queres retirar o máximo do WeTransfer?',
      },
    },
    welcome: {
      card1:
        'Envia e recebe %{transfer_limit} transferências com um só <strong>resumo partilhado</strong>',
      card2:
        'Entrega trabalho a partir da <strong>página personalizada</strong> da tua equipa no WeTransfer',
      card3:
        'Colabora em conjuntos de diapositivos no <strong>Paste®</strong> e quadros no <strong>Collect</strong>',
      cta: 'Vamos começar',
      headline: 'Estás na equipa, <strong>%{first_name}!</strong>',
      'opt-in':
        'Quero receber histórias de criatividade e notícias do WeTransfer',
    },
    form: {
      num_files: {
        one: '%{count} ficheiro · Faltam %{remaining}',
        other: '%{count} ficheiros · Faltam %{remaining}',
      },
      add_files: 'Carregar ficheiros',
      more_files: 'Adicionar mais ficheiros',
      available_space: 'Adicionar até %{size}',
      message: 'Mensagem',
      from: 'O teu e-mail',
      to: 'Endereço de e-mail para envio',
      other_recipients: {
        one: '+%{count} outro',
        other: '+%{count} outros',
      },
      reset_forward: 'Cancelar este reencaminhamento',
      drop_files: 'ou arraste e solte',
      files_count: {
        one: '%{count} ficheiro adicionado · %{fileSize} no total',
        other: '%{count} ficheiros adicionados · %{fileSize} no total',
      },
      select_folder: 'Ou seleciona um arquivo',
    },
    progress: {
      title: 'A transferir...',
      title_cancel: 'Cancelar esta transferência?',
      uploaded: '%{sent} de %{total} carregados',
      remaining: {
        minutes: {
          zero: 'Menos de 1 minuto restante',
          one: 'Cerca de 1 minuto restante',
          other: 'Cerca de %{count} minutos restantes',
        },
        hours: {
          one: 'Cerca de 1 hora restante',
          other: 'Cerca de %{count} horas restantes',
        },
      },
      document_title: '%{percentage}% - A transferir...',
      meta: {
        email: {
          one_file_one_recipient:
            'A enviar %{filesCount} ficheiro para %{recipientsCount} pessoa',
          one_file_other_recipients:
            'A enviar %{filesCount} ficheiro para %{recipientsCount} pessoas',
          other_files_one_recipient:
            'A enviar %{filesCount} ficheiros para %{recipientsCount} pessoa',
          other_files_other_recipients:
            'A enviar %{filesCount} ficheiros para %{recipientsCount} pessoas',
        },
        link: {
          one: 'A enviar %{count} ficheiro',
          other: 'A enviar %{count} ficheiros',
        },
      },
    },
    complete_link: {
      title: 'Já está!',
      text: 'Copia o link para download ou <a href="/transfer/progress">pré-visualiza</a>',
      text_copied: 'O link foi copiado para a tua área de transferência',
      text_manual_copy:
        'O teu link está pronto\nPrime %{shortcut} para o copiar para a tua área de transferência ',
      document_title: 'Pronto!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'A tua transferência foi reencaminhada',
    },
    complete_email: {
      title: 'Já está!',
      text: 'O e-mail de transferência foi enviado – a tua transferência está disponível durante %{expires}. <a href="/transfer/progress">Pré-visualiza</a>',
      text_no_expiry:
        'O e-mail de transferência foi enviado. <a href="/transfer/progress">Pré-visualiza</a>',
      document_title: 'Enviado!',
      text_no_details:
        'O e-mail de transferência foi enviado - a tua transferência está disponível durante %{expires}',
      team_discovery_title: 'Transferência enviada!',
      team_discovery_text:
        'A tua transferência estará disponível para download durante %{expires}',
    },
    failed: {
      title: 'Hmm, ocorreu um problema',
      text: 'Parece que a tua transferência falhou – tenta novamente',
    },
    pending: {
      title: 'Estamos quase lá',
      subtitle: 'A preparar...',
    },
    downloading: {
      title: 'A obter os teus ficheiros...',
      text: 'Estamos a preparar o teu download',
    },
    downloaded: {
      title: 'O teu download já começou',
      text: 'Os ficheiros já estão no teu computador, \nnormalmente na tua pasta de downloads.',
      download_links:
        'Esteja consciente do facto que os links neste Board não irão aparecer - <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">leia mais aqui</a>.',
    },
    expired: {
      title: 'Transferência expirada',
      text: 'Pedimos desculpa, esta transferência expirou e já não está disponível',
    },
    password: {
      title: 'Introduzir palavra-passe',
      text: 'É necessária uma palavra-passe para fazer download desta transferência',
    },
    options: {
      transfer_type: 'Enviar como',
      password: 'Palavra-passe',
      password_placeholder: 'Definir',
      expiry: 'Expira após',
      expire_in: {
        '1w': '1 semana',
        '2w': '2 semanas',
        '1m': '4 semanas',
        never: 'Nunca',
        '14d': '2 semanas',
        '28d': '4 semanas',
        '365d': '1 ano',
        '7d': '1 semana',
        '90d': '3 meses',
      },
      email: 'e-mail',
      link: 'link',
      email_transfer: 'Enviar transferência por e-mail',
      transfer_link: 'Obter link de transferência',
    },
    buttons: {
      transfer: 'Transferir',
      forward: 'Reencaminhar',
      new_transfer: 'Enviar ficheiro?',
      cancel: 'Cancelar',
      cancel_no: 'Não',
      cancel_yes: 'Sim',
      copy_link: 'Copiar link',
      ok: 'Ok',
      done: 'Enviar outro?',
      team_discovery_done: 'Enviar nova transferência',
      retry: 'Tenta novamente',
      continue: 'Continuar',
      download: 'download',
      download_all: 'Descarrega tudo',
      back_to_home: 'Voltar à página principal',
      cleanup: 'Rever transferências ',
      download_all_files: 'Fazer download de todos os ficheiros',
      help: 'Centro de ajuda',
      payment: 'Renovar agora',
      complete_order: 'Finalizar compra',
      download_all_experiment: 'Download tudo como um .zip',
      download_experiment: 'Download ficheiro',
      download_file: 'Descarregar ficheiro',
      download_zip: 'Descarregar como ficheiro .zip',
      get_link: 'Obter link',
      go_to_transfer: 'Ir para a transferência',
      openinapp: 'Guardar na aplicação',
      openinapp_experiment: 'Guardar com a aplicação Wetransfer',
      openincollectapp: 'Guardar com a Collect App.',
      get_a_link: 'Obtém um link',
    },
    account_expired: {
      text: 'Renova agora para continuares a tirar partido de todas as vantagens da tua conta Pro, ou <a href="#signout">termina sessão para usar o nosso serviço gratuito</a>',
      title: 'A tua conta Pro expirou',
    },
    invalid: {
      text: 'Não foi possível localizar os teus ficheiros',
      title: 'Ups...',
      link: 'Saiba mais',
    },
    outdated_browser: {
      text: 'O WeTransfer suporta toda uma gama de Web Browsers, mas parece que este é demasiado antigo — atualiza o teu browser',
      title: 'O teu Web browser está desatualizado',
    },
    spam: {
      text: 'Esta transferência foi considerada spam, e foi eliminada',
      title: 'Hmm...',
    },
    upsell: {
      text: 'Increase limit',
      limit: 'Up to %{limit} free',
      remaining: '%{remaining} remaining',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Obtém o WeTransfer Pro',
      title: 'Transferências com palavra-passe, para extra segurança',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Obtém o WeTransfer Pro',
      title:
        'Uma forma mais fácil e inteligente de gerir as tuas transferências',
    },
    upsell_one: {
      bubble: {
        button: 'Obtém o Pro',
        text: 'Protege as tuas transferências com uma palavra-passe e define uma data de expiração à escolha',
        title: 'Atualizar para o Pro?',
        text_experiment:
          'Com o Pro, podes configurar palavras-passe e datas de expiração para as tuas transferências.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer no Facebook',
      title: 'Junta-te à comunidade WeTransfer no Facebook',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Obtém o WeTransfer Pro',
      title: 'Personaliza o teu perfil WeTransfer',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Obtém o WeTransfer Pro',
      title: 'Torna-te maior, melhor, mais forte, mais rápido',
    },
    account_inactive: {
      text: 'Conclui o teu registo para começar com o Pro',
      title: 'A tua conta ainda \nnão está ativa ',
      tiers: {
        text: 'Completa o teu pagamento para começares com %{plan}.',
        title: 'A tua assinatura ainda não está ativa',
      },
    },
    add_items: {
      files: 'Ficheiros',
      folders: 'Pastas',
    },
    complete: {
      open_panel:
        '<a href="/transfer/progress">Queres ver o que está lá dentro</a>?',
    },
    details: {
      button: {
        dismiss: 'Rejeitar',
      },
    },
    download_preview: 'Descarregar ficheiro',
    error: {
      expired: {
        link: 'Contacta a nossa equipa de suporte.',
        text: 'Parece que a tua transferência já expirou. \nNão te parece correto?',
        title: 'A transferência expirou',
      },
    },
    item: {
      details: {
        folder: 'Arquivo',
      },
    },
    items: {
      zero: 'artigos',
      one: '%{count} artigo',
      other: '%{count} artigos',
    },
    mobile: {
      button: {
        back: 'Voltar',
        cancel: 'Recomeça',
        next: 'Seguinte',
      },
      email: {
        title: 'Adiciona endereços de e-mail',
      },
      message: {
        placeholder: 'Adiciona uma mensagem à tua transferência',
        title: 'Mensagem',
      },
      options: {
        email: 'Envia um e-mail',
        'email-description':
          'Envia a tua transferência com um simples e-mail e iremos informar-te quando a mesma for descarregada.',
        link: 'Obtém um link',
        'link-description':
          'Transforma os teus ficheiros num link e partilha-os como quiseres.',
      },
    },
    recaptcha: {
      button: 'Sou 100% humano',
      text: 'Precisamos apenas de verificar que não és um robot (sem ofensa)',
      title: 'Estás quase pronto!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Ajuda-nos',
      title: 'Podemos perguntar-te algo sobre a tua forma de trabalhar?',
    },
    'verification-code': 'Código de verificação',
    verify: {
      button: 'Iniciar transferência',
      text: 'Verifique a sua caixa de entrada para um código de verificação e insira-o abaixo',
      title: 'Recebeu um e-mail.',
      'verification-code': 'Código de verificação',
    },
    'account-verification-failed': {
      body: 'Estamos a ter dificuldades em confirmar o teu email. Enviar um novo link para tentar novamente.',
      cta: 'Enviar um novo link?',
      title: 'Houve algo errado',
    },
    'cookie-banner': {
      'button-accept': 'Ok',
      'button-decline': 'Não',
      text: 'Utilizamos <a href="%{href}">cookies</a> que permitem o bom funcionamento do site, que nos permitem analisar a forma como os nossos utilizadores interagem com o mesmo, e que nos ajudam a melhorar o site. Também desejas autorizar os cookies de terceiros para receberes publicidades personalizadas?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Utilizamos cookies analíticos para nos ajudar a compreender como utilizas a WeTransfer. Permitem-nos testar novas funcionalidades, assegurar que tudo está a funcionar como deveria e parar os bots e comportamentos maliciosos como o spam. Estes cookies podem incluir cookies de terceiros que processam informações pessoais. ',
        title: 'Cookies analíticos',
      },
      clear: {
        'clear-all-cookies': 'Limpar todos os cookies',
        description:
          'Podes remover todos os teus dados dos nossos cookies. Para pedidos de anonimato permanente, contactar <a href="mailto:support@wetransfer.com">contacta a nossa equipa de suporte.</a>',
        title: 'Limpar cookies',
        warning:
          'Serás desconectado da WeTransfer depois de limpares os cookies. Isto não afetará as transferências na tua conta.',
      },
      functional: {
        description:
          'Utilizamos cookies funcionais para te proporcionar uma experiência ininterrupta na WeTransfer. Eles são obrigados a usar o nosso serviço.',
        title: 'Cookies funcionais',
      },
      'not-yet-set':
        'Parece que ainda não nos deste a tua preferência por cookies. Fecha este painel e define a tua preferência, podes sempre alterá-lo aqui depois.',
      'save-and-reload': 'Guardar definições',
      tracking: {
        description:
          'Utilizamos cookies de publicidade no nosso serviço para nos ajudar a medir o sucesso dos nossos esforços comerciais, editoriais e promocionais. Os cookies publicitários não são colocados em páginas que forneçam informações sobre a nossa marca e produtos. Os cookies publicitários permitem-nos registar, por exemplo, que clicaste num determinado anúncio. Se os cookies colocados por terceiros forem também colocados noutros domínios e websites, os anunciantes podem ser capazes de seguir o teu comportamento através da Internet, mas a WeTransfer não pode aceder ou utilizar nenhuma destas informações pessoais que possam ser recolhidas. Como tal, remetemos-te para as políticas de privacidade relevantes de terceiros.',
        title: 'Cookies publicitários',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Ups, ocorreu um erro',
        'error-email-exists': 'Ups, parece que este e-mail já foi utilizado',
        'throttle-error':
          'Uau, já te enviámos demasiados e-mails. Por favor aguarda %{throttle_time} antes de solicitares um novo código.',
      },
      back: 'Regressar à verificação com código',
      body: 'Estamos certos? É este e-mail que estás a utilizar no WeTransfer.',
      email: 'E-mail',
      error: 'Ups, ocorreu um erro',
      'error-email-exists':
        'Ups, parece que este e-mail já está a ser utilizado',
      submit: 'Reenviar',
      'throttle-error':
        'Desculpa, já tentaste demasiadas vezes. Por favor reinicia novamente a tua transferência.',
      'throttle-error-action': 'Começar novamente',
      'throttle-error-link':
        'Uau, já te enviámos demasiados e-mails. Por favor aguarda %{throttle_time} antes de solicitares um novo e-mail.',
      title: 'Verifica o teu e-mail',
    },
    'email-verification-success': {
      body: 'Agora, os destinatários das tuas transferências podem ter a certeza que elas foram realmente enviadas por ti.',
      free_signup: 'Cria uma conta gratuita',
      onboarding_body:
        'Muito bem, já estás inscrito! Estás pronto para escolher o teu endereço e fundos de ecrã?',
      onboarding_title: 'Bem-vindo ao<br/>WeTransfer Pro!',
      send_files: 'Enviar ficheiros',
      start_onboarding: 'Vamos lá',
      title: 'A tua conta foi verificada!',
      upsell:
        'Não queres verificar o teu e-mail sempre que precisares de enviar um ficheiro?',
      verified_sender_tooltip:
        'O teu e-mail está verificado, o que permite que as pessoas confiem nas transferências enviadas por ti. Para alterares este e-mail, atualiza os teus <a href="%{href}">dados pessoais</a>.',
      verified_sender_tooltip_icon:
        'Verificaste o teu endereço de e-mail. Isto permite que as pessoas confiem nas transferências enviadas por ti.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Ups, esse código é errado ou expirou. Os códigos só ficam ativos durante %{expiry_time} após o seu envio.',
        'error-expiry-time-action': 'Obtém um novo código',
        'throttle-error':
          'Inseriste um código errado ou expirado demasiadas vezes. Por favor aguarda %{throttle_time} antes de solicitares um novo código.',
      },
      back: 'Regressar',
      body: 'Enviámos um código de verificação para <strong title="%{account_email}">%{account_email}</strong> para ter a certeza de que é realmente você. (lembre-se de verificar a sua pasta Spam).',
      body_link:
        'Só um controlo rápido para sabermos que és tu.<br/><br/>  Enviámos-te um link de verificação para <strong title="%{account_email}">%{account_email}</strong> (se não o encontrares, vê o teu arquivo de spam).',
      error: 'Ups, esse código está errado ou já não é válido.',
      'error-expiry-time':
        'Ups, esse código é errado ou expirou. Os códigos só ficam ativos durante %{expiry_time}após o seu envio.',
      'error-expiry-time-action': 'Obtem um novo código',
      resend: 'Não recebeste um e-mail?',
      submit: 'Verifica-me',
      'throttle-error':
        'Desculpa, já tentaste demasiadas vezes. Por favor reinicia novamente a tua transferência.',
      'throttle-error-action': 'Começar novamente',
      title: 'Confirma o teu e-mail',
      'verification-code': 'Insere código de verificação',
    },
    'force-account-verification': {
      body: 'Vamos enviar-te um link por e-mail para confirmar o endereço que estás a usar no WeTransfer.',
      cta: 'Enviar e-mail',
    },
    'marketing-email-prompt': {
      body: 'Mais uma coisa - gostarias de receber notícias e atualizações de produtos do WeTransfer?',
      skip: 'Não, obrigado',
      subscribe: 'Sim, mantenham-me a par',
      title: 'Verificação efetuada!',
    },
    'terms_conditions-no-cookies': {
      text: 'Para continuar, por favor aceita os nossos <a href="/legal/terms?from_home" data-route-type="plus">Termos de Serviço</a>.',
    },
    mobile_web: {
      ios_banner_prompt: 'Recebe os teus ficheiros na aplicação WeTransfer',
      ios_banner_prompt_send: 'Envia ficheiros de forma rápida e fácil',
      tnc_subtitle: 'A forma mais simples de enviar grandes ficheiros',
    },
  },
  account: {
    legend: {
      plan: 'Plano',
      save: 'guardar %{amount}%',
      subscription: 'Assinatura',
      summary: 'Resumo de encomenda',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Porque te estamos a pedir para confirmares o teu e-mail',
    workspace: {
      default_workspace: 'Espaço de trabalho de %{name}',
      your_workspace: 'O seu espaço de trabalho',
    },
    consent_manager: {
      data_opt_in: {
        title: 'As tuas escolhas de privacidade',
        subtitle: 'Gere os teus dados',
        p1: 'Queremos proporcionar-te sempre a melhor experiência possível, mesmo quando se trata da nossa publicidade.',
        p2: 'Gostaríamos de partilhar os dados que optares por partilhar, como o teu endereço de e-mail, para percebermos qual é o tipo de conteúdo de que mais gostas e utilizar essa informação para te apresentar (e a outras pessoas como tu) anúncios do WeTransfer mais personalizados.',
        p3: 'Tudo o que crias e partilhas com o WeTransfer é privado e só teu. Não lemos nem utilizamos o que é teu para fins de publicidade.',
        p4: 'Se decidires partilhar connosco, estas informações estão sempre seguras.',
        control_label:
          'Permite que o WeTransfer utilize os dados que partilhas, como o teu e-mail e área de trabalho, para personalizares os anúncios que vês dentro e fora dos nossos Websites.',
      },
      vertical_nav: {
        terms_of_service: 'Termos de Serviço',
        privacy_and_cookie_statement: 'Declaração de Privacidade e Cookies',
        your_privacy_choices: 'As tuas escolhas de privacidade',
        notice_and_takedown_policy: 'Política de Aviso e Desativação',
        responsible_disclosure_policy: 'Política de Divulgação Responsável',
        advertising_terms_and_conditions: 'Termos e Condições de Publicidade',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Fecha e vai enviar ficheiros',
  },
  account_start_screen: {
    'collect-description':
      'Guarda toda a tua inspiração num só lugar, quer estejas ao telefone, no teu computador portátil ou tablet.',
    'collect-title': 'Ir para Collect',
    'paste-description':
      'Cria bonitos diapositivos em segundos com conjuntos de apresentação que se desenham a si próprios.',
    'paste-title': 'Ir para o Paste®',
    title: 'Três ferramentas. Uma conta. Infinitas possibilidades.',
    'transfer-cta': 'Vamos a isso',
    'transfer-description':
      'Cria uma impressão marcante a cada vez que alguém descarrega os teus ficheiros. Estás pronto para escolher o teu próprio endereço URL e fundos de ecrã?',
    'transfer-title': 'Configura a tua própria página no WeTransfer',
  },
  account_welcome_screen: {
    'pro-title': 'Bem-vindo à WeTransfer Pro, <strong>%{name}!</strong>',
    accept: 'Sim, por favor',
    'accept-short': 'Ok',
    body_1:
      'Queres ficar a par das histórias sobre criatividade e as últimas novidades do WeTransfer?',
    body_2: '(Podes sempre cancelar a tua inscrição mais tarde)',
    decline: 'Não, obrigada',
    'decline-short': 'Não, obrigado',
    title: 'Bem-vindo ao WeTransfer, <strong>%{name}!</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Aceitar cookies',
      deny: 'Negar cookies',
      manage: 'Gerir cookies',
    },
    description:
      'Usamos cookies regulares e cookies analíticos para garantir uma ótima experiência e cookies de terceiros para fins publicitários.',
    heading: 'Descobre a forma mais simples de enviar grandes ficheiros',
    snippet: 'Bem-vindo à WeTransfer',
  },
  dropzone: {
    pro: {
      title: "<span>Drop</span> it<br>like it's hot",
    },
    title: "Drop it like it's hot",
    text: 'Carrega os ficheiros ou arquivos largando-os nesta janela',
  },
  form: {
    account: {
      billing_address: 'Endereço de faturação',
      billing_cta: 'Ir para pagamento',
      billing_title: 'Dados de faturação',
      legend: {
        details: 'Informações de faturação',
        coupon_code: 'Adicionar um código de desconto',
        free_plus: 'Obtém a tua conta Pro gratuita',
      },
      label: {
        year_label: 'Anual',
        year_sublabel: 'A melhor oferta: poupa %{discount_rate}%!',
        month_label: 'Mensal',
        month_sublabel: 'Faturação recorrente',
        email: 'Endereço de e-mail',
        not_required: '(opcional)',
        current_password: 'Palavra-passe atual',
        new_password: 'Nova palavra-passe',
        repeat_new_password: 'Confirmar nova palavra-passe',
        password: 'Palavra-passe',
        password_confirm: 'Confirmar palavra-passe',
        full_name: 'Nome completo',
        company: 'Empresa',
        street_and_number: 'Morada',
        city: 'Cidade',
        zipcode: 'Código postal',
        country_code: 'País',
        vat_number: 'IVA',
        coupon_code: 'Código de desconto',
        family_name: 'Apelidos',
        given_name: 'Nome próprio',
        state_code: 'Estado',
      },
      description: {
        password:
          'Seleciona uma palavra-passe que contenha um mínimo de 6 caracteres',
        vat_number:
          'Às empresas localizadas nos Países Baixos, cobramos o IVA a 21%. Se a tua empresa estiver localizada em qualquer outro país da UE, introduz os dados da empresa, bem como o NIF, para podermos remover o IVA da fatura. \n \nSe a tua empresa estiver localizada fora da zona abrangida pelo IVA dos países da UE, precisamos igualmente das tuas informações de faturação, mas não cobraremos IVA.',
      },
      error: {
        email: {
          blank: 'Introduz o teu endereço de e-mail',
          invalid: 'Introduz um endereço de e-mail válido',
          taken: 'Este endereço de e-mail já está a ser utilizado',
          taken_login:
            'Parece que já tens uma conta. <a class="form-notification__message-link" href="%{login_url}">Vamos iniciar sessão?</a>',
        },
        current_password: {
          invalid: 'Palavra-passe não reconhecida',
          blank: 'Introduz a tua palavra-passe atual',
        },
        password: {
          blank: 'Introduz a tua nova palavra-passe',
          too_short:
            'A tua palavra-passe deve conter um mínimo de 6 caracteres',
        },
        password_confirm: {
          blank: 'Confirma a tua nova palavra-passe',
          confirm: 'Estas palavras-passe não coincidem',
        },
        full_name: {
          blank: 'Introduz o teu nome completo',
          too_short:
            'Ups, o seu nome necessita de ter pelo menos três caracteres',
        },
        street_and_number: {
          blank: 'Introduz a tua morada',
        },
        city: {
          blank: 'Introduz a tua cidade',
        },
        zipcode: {
          blank: 'Introduz o teu código postal',
        },
        country_code: {
          inclusion: 'Verifica a tua ortografia, ou escolhe outro país',
          blank: 'Introduz o teu país',
        },
        vat_number: {
          vat_number: 'Introduz um NIF válido',
        },
        terms_of_service: {
          accepted: 'Para continuar, aceita os nossos Termos de serviço',
        },
        no_results: 'Verifica a tua ortografia, ou escolhe outro país',
        convert: {
          expired:
            'Infelizmente, esta transferência já expirou e agora não pode ser guardada. Sabias que com o WeTransfer Pro podes manter as transferências durante o tempo que quiseres? Descobre mais aqui.',
        },
        coupon_code: {
          coupon_code: 'Introduz um código de desconto válido',
        },
        no_state_results: 'Isto é um estado?',
      },
      complete_order: 'Conclui a encomenda',
      terms_conditions:
        'Aceito os <a href="/legal/terms" %{options}>Termos de Serviço</a>e li a <a href="/legal/privacy" %{options}>Declaração de Privacidade e de Cookies</a>',
      signup_for_plus: 'Inscreve-te no WeTransfer Pro',
      account_cta: 'Vamos lá',
      signup_for_account: 'Abre uma conta WeTransfer',
      'email-verification-not-verified-link':
        'Por favor verifica o teu endereço de e-mail. Verifica o e-mail que te enviámos, ou <button type="button" class="button button--link">solicita um novo e-mail</button>.',
      'email-verification-resend': {
        error: 'Ups, ocorreu um erro',
        info: 'Novo código enviado! Por favor verifica a tua caixa de entrada',
        info_link:
          'Novo e-mail enviado! Por favor verifica a tua caixa de entrada',
        'throttle-error':
          'Uau, já te enviámos demasiados e-mails. Por favor aguarda %{throttle_time} antes de solicitares um novo código.',
      },
      'force-account-verification': {
        message:
          'Por favor verifica o teu endereço de e-mail para confirmar que és mesmo tu.',
      },
      marketing_opt_in: 'Desejo obter novidades e atualizações do WeTransfer',
      sso: {
        header: 'Dados pessoais',
        password_reset: {
          button: 'Enviar e-mail',
          instructions:
            'Precisas de uma pequena alteração (palavra-passe)? Deixa connosco. Basta carregar no botão abaixo e enviaremos um e-mail para <span>%{email}</span> com um link para alterar a tua palavra-passe.',
          success: 'E-mail enviado! Verifica a tua caixa de entrada.',
          title: 'Altera a tua palavra-passe',
        },
        wrong_user: 'Não és tu? Sair',
      },
    },
    payment_cancel: {
      submit: 'Confirmar',
      client_request:
        'Um cliente tinha pedido para eu utilizar o WeTransfer, mas agora já não preciso',
      different_tool: 'Encontrei uma plataforma diferente',
      extra_features:
        'Preciso de funcionalidades que esta assinatura não oferece',
      not_enough_storage: 'Não há espaço suficiente para mim',
      not_often_large_files:
        'Não envio frequentemente ficheiros de grandes dimensões',
      other: 'Outro',
      other_more: 'Pode contar-nos mais?',
      skip: 'Passar e cancelar assinatura',
      temp_project:
        'Só necessitava de enviar ficheiros de grandes dimensões para um projeto temporário',
      too_expensive: 'Acho demasiado caro',
    },
    payment_cancel_reason: {
      skip: 'Não quero dar feedback',
    },
    profile: {
      label: {
        profile_title: 'Nome do perfil',
        wallpaper_link: 'Web site para ligar padrões de fundo a',
      },
      error: {
        subdomain_name: {
          too_short:
            'Nós sabemos que menos é mais, mas a tua URL personalizada do WeTransfer tem de ter um mínimo de 2 caracteres',
          domain_name: 'Infelizmente, este nome já existe',
          invalid:
            'Isso é demasiado estranho - a tua URL personalizada do WeTransfer só pode conter letras e dígitos (e um travessão entre dois segmentos)',
          taken: 'Infelizmente, este nome já existe',
        },
        subdomain: {
          too_short: 'Tem de ter, pelo menos, 2 caracteres',
          too_long: 'Vá lá, tem de ter menos de 63 caracteres',
          invalid:
            'Isso é demasiado estranho — o teu URL do WeTransfer só pode conter letras e dígitos (e um travessão entre dois segmentos)',
          domain_name: 'Este URL já foi escolhido',
        },
        default_recipient_email: {
          invalid: 'Introduz um endereço de e-mail válido',
        },
        wallpaper_link: {
          invalid: 'Introduz um endereço Web válido',
        },
      },
      success: {
        subdomain: {
          updated: 'O teu URL foi atualizado',
          available: 'Boas notícias, este URL está disponível',
        },
      },
      change_background: 'Carregar fundo',
      delete_avatar: 'Eliminar avatar',
      delete_background: 'Eliminar fundo',
      description: {
        title:
          'Este título aparece no canto inferior direito da tua página de perfil para que nada seja excluído',
        wallpaper_link:
          'Os teus padrões de fundo vão ligar-se a este endereço Web',
        recipient_email_locked:
          'Os ficheiros enviados através do teu perfil só serão enviados para este endereço de e-mail',
      },
      upload_avatar: 'Carregar avatar',
      use_email_background_checkbox_label:
        'Usar este padrão de fundo para todas as transferências enviadas através do meu perfil',
      account_email_checkbox: 'Mostrar e-mail no perfil',
      default_recipient_email_info:
        'Podes modificar este endereço de e-mail nos teus <a href="/account">dados pessoais</a>',
      change_subdomain: {
        message:
          'Queres alterar o URL para <a href="%{url}">%{subdomain}.wetransfer.com</a>? O anterior vai ficar disponível para outros imediatamente.',
        confirm: 'Sim, alterar URL',
        cancel: 'Voltar',
      },
    },
    fill_in_password:
      'Introduz a tua palavra-passe para guardar estas alterações',
    select_all: 'Selecionar tudo',
    deselect_all: 'Anular seleção',
    save_changes: 'Guardar alterações',
    save: 'Guardar',
    submitting: 'A submeter...',
    cancel: 'Cancelar',
    forward: 'Reencaminhar',
    proceed: 'Continuar',
    delete: 'Eliminar',
    onboarding: {
      placeholder: {
        subdomain_name: 'escolhe-um-bom-nome',
      },
      validated: {
        subdomain_name: 'Boas notícias – este domínio está disponível',
      },
    },
    confirm_leave:
      'Tens a certeza de que pretendes sair desta página e perder as alterações não guardadas?',
    unsaved_changes:
      'Queres sair da página? Vais perder as alterações não guardadas.',
    contact: {
      add_contact: 'Adicionar contacto',
      error: {
        email: {
          duplicate:
            'Este endereço de e-mail já está na tua lista de contactos',
          invalid: 'Introduz um endereço de e-mail válido',
        },
      },
      label: {
        company: 'Empresa',
        email: 'Endereço de e-mail',
        name: 'Nome',
      },
    },
    error: {
      current_password: {
        blank: 'Introduz a tua palavra-passe atual',
        invalid: 'Palavra-passe não reconhecida',
      },
      email: {
        blank: 'Introduz o teu endereço de e-mail',
        duplicate: 'Este endereço de e-mail já está na tua lista de contactos',
        invalid: 'Introduz um endereço de e-mail válido',
        taken: 'Este endereço de e-mail já está a ser utilizado',
      },
    },
    leave: 'Sair',
    resetpassword: {
      button: {
        request_submit: 'Enviar',
        reset_submit: 'Guardar nova palavra-passe',
      },
      label: {
        confirm_new_password: 'Confirmar nova palavra-passe',
        email: 'Endereço de e-mail',
        new_password: 'Nova palavra-passe',
      },
      legend: {
        request_description:
          'Ficaste bloqueado? Vamos enviar-te instruções sobre como redefinir a tua palavra-passe e continuar.',
        request_title: 'Esqueceste-te da tua palavra-passe?',
        reset_description:
          'Introduz uma nova palavra-passe para voltar a entrar',
        reset_title: 'Definir uma palavra-passe nova',
        request_description_success_or_article:
          'Se tens uma conta no WeTransfer, enviámos-te instruções para reconfigurares a tua palavra-passe. Consulta este <a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external"> artigo do Centro de Suporte</a> se não receberes um e-mail nos próximos minutos.',
      },
    },
    signin: {
      button: {
        submit: 'Iniciar sessão',
      },
      label: {
        email: 'Endereço de e-mail',
        password: 'Palavra-passe',
        remember_me: 'Lembrar-me',
      },
      link: {
        forgot_password: 'Esqueceste-te da palavra-passe?',
      },
      title: 'Aceder',
    },
    stay_on_page: 'Permanecer na página',
    close_panel: 'Fechar',
    go_back: 'Regressar',
    labels: {
      email: 'Endereço de e-mail',
    },
    plan: {
      change: {
        month: 'Mensal (%{currency} %{price})',
        title: 'Mudar de plano',
        year: 'Anual (%{currency} %{price})',
      },
      change_plan: 'Modificar plano de pagamento',
      month: {
        copy: 'Faturação periódica',
        label: 'Mensal',
        'label-payment': 'Pagamento mensal',
        'sub-label': 'Uma só fatura, todos os meses',
        title: 'WeTransfer Pro: pagamento mensal',
      },
      title: 'Dê às suas ideias o tratamento premium que merecem',
      year: {
        discount: 'Poupa %{rate}% (que bom!)',
        'label-payment': 'Pagamento anual',
        'sub-label': 'É uma poupança de 17%. Boa',
        title: 'WeTransfer Pro: pagamento anual',
      },
      your_order: 'A sua encomenda',
    },
    save_and_continue: 'Guardar e continuar',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Insere a tua palavra-passe para continuar',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Agora não',
        true: 'Abre no app WeTransfer',
      },
      headline: 'Por que não pensar grande?',
      headline2: 'Quer visualizar ficheiros no app?',
      subheader: 'Envia e recebe 200 GB com o WeTransfer Pro',
      subheader2:
        'Visualiza os ficheiros antes de transferi-los. Envia e recebe transferências, controla as transferências, e recebe notificações.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Renova já para continuares a usufruir de todas as vantagens da tua conta %{tier}',
      account_expired_title_tier: 'A tua conta %{tier} expirou',
      account_inactive_title_tier: 'Tudo a postos para mudares para o %{tier}',
      account_inactive_action: 'Sim, continuar',
      account_inactive_subtitle:
        'Só mais um passo e já terminaste. Mudaste de ideia? Tudo bem—',
      account_inactive_title: 'Estás pronto para passar a ser um Pro?',
      account_subscription_action: 'Renovar agora',
      account_subscription_expired: 'A tua conta Pro expirou',
      account_subscription_subtitle:
        'Renova agora para manteres as tuas transferências, os teus padrões de fundo pessoais e o endereço Web. Caso contrário, estes serão eliminados em breve.',
      account_expired_action: 'Renovar agora',
      account_expired_subtitle:
        'Renova agora para continuares a tirar partido de todas as vantagens da tua conta Pro',
      account_expired_title: 'A tua conta Pro expirou',
      expired_transfer_subtitle:
        'Os ficheiros já não se encontram disponíveis. Pode apagar as informações do seu resumo de transferências <a>aqui</a>.',
      expired_transfer_title: 'Esta transferência expirou',
      account_email_verify_logged_out:
        'Por favor efetua login para verificar o teu e-mail',
      account_inactive_sublink: 'cancela a tua encomenda.',
      email_unverified_mobile_cta: 'Pronto para verificar',
      email_unverified_text:
        "Enviámos um código de verificação para %{email}. <a href='%{href}'>Não foste tu?</a>",
      email_unverified_text_link:
        "Enviámos um e-mail para %{email}. <a href='%{href}'>Não és tu?</a>",
      email_unverified_title: 'Por favor verifica o teu endereço de e-mail',
      'force-account-verification': {
        body: 'Vamos enviar-te um link por e-mail para confirmarmos que és mesmo tu.',
      },
      'receiving-email':
        'Atenção! Substituímos %{receiving_email} no teu perfil. Isto significa que as novas transferências só irão aparecer no teu resumo de transferências se forem enviadas para %{account_email}. Para modificar esta opção, atualiza dos teus <a href="/account">dados pessoais</a> em qualquer altura.',
    },
    design:
      'Provavelmente, já notaste que fizemos algumas alterações por aqui. Muitas delas estão relacionadas com aspetos que tu querias ver alterados. Por isso, diverte-te a explorar o site novo e (ousamos dizer) melhorado, e envia-nos qualquer feedback para aqui.',
    loading_error:
      'Ocorreram problemas nesta página ao carregar neste momento. \nVamos continuar a tentar, ou <a href="%{path}">tenta atualizá-la</a> manualmente. ',
    redesign_notice:
      'Provavelmente já notaste que <a href="/about/redesign">fizemos algumas alterações</a> por aqui! Muitas delas são mudanças que tu disseste que gostarias de ver acontecer. Por isso, diverte-te a explorar o site novo e (ousamos dizer) melhorado. Depois, <a href="/contact" rel="external">envia-nos qualquer feedback para aqui<a/>.',
    return_to: 'voltar a %{pageName}',
    close: 'Fechar o painel',
    cookie: {
      accept: 'Ok',
      text: 'Nós utilizamos cookies. Lê <a href="/legal/terms">os documentos legais</a> (receitas não incluídas).',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Trabalhos',
      press: 'Imprensa',
      terms: 'Termos',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Faz o upgrade',
    free_limit:
      'Não podes enviar mais do que 2 GB de uma só vez. Queres enviar maiores transferências?',
    compare_plans: {
      button: 'Comparar planos',
      text: 'Podes fazer upgrade do teu plano para transferires mais de 2 GB de cada vez.',
      title: 'Tens mais ficheiros para enviar?',
    },
    mobile: {
      cta: 'Fica a saber mais',
      header: 'Obtém o melhor do WeTransfer',
      upsell_enjoy: 'Desfruta de mais espaço de armazenamento',
      upsell_one: 'Envia maiores transferências',
      upsell_two: 'Personaliza a tua página do WeTransfer',
    },
    pro_limit:
      'Não podes enviar mais do que 200 GB de uma só vez. Queres enviar transferências de qualquer tamanho?',
  },
  upsell_tiers_one: {
    text: 'Desejas configurar palavras-passe e datas de expiração para as tuas transferências?',
  },
  upsell_tiers_three: {
    text: 'Queres enviar transferências para mais de %{email_limit} endereços de uma só vez?',
    title: 'Tens um a mais',
  },
  browser: {
    assets_failed: {
      text: 'Não foi possível carregar algumas partes importantes do nosso website.\nEstas podem ter sido bloqueadas pela tua firewall, proxy ou configuração do browser. Tenta atualizar a página ou entra em contacto com o nosso <a href="https://wetransfer.zendesk.com" rel="external">centro de ajuda</a>.',
      title: 'Oh, não!',
    },
    javascript_needed:
      'Para poderes usar o WeTransfer, precisas de um browser compatível com JavaScript.',
  },
  languages: {
    en: 'Inglês',
    nl: 'Países Baixos',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'Esta oferta está disponível até %{end_date}. O desconto aplica-se ao seu primeiro ano de %{user_tier}, após o qual a assinatura será renovada pelo preço total de %{yearly_amount}/%{billing_period}.',
    },
    modal: {
      title: '%{discount_amount}% de desconto anual no Pro',
      subtitle: 'Código de desconto: %{coupon_code_name}',
      text_content:
        'É isso mesmo. É a nossa oferta. Estamos a oferecer um desconto de %{discount_amount}% num plano Pro anual.',
      argument: {
        size_limit:
          'Podes enviar e receber transferências de ficheiros de 200 GB',
        storage_size: 'Aproveita 1 TB de armazenamento',
        unlimited_review: 'Cria revisões ilimitadas',
      },
      cta_label: 'Obter desconto',
      dismiss_label: 'Agora não',
    },
    banner: {
      title:
        'Obtém %{discount_amount}% de desconto no plano WeTransfer Pro por um ano - a nossa melhor oferta até agora',
      cta_label: 'Fazer o upgrade',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title: 'Cria uma equipa para transferências com %{first_recipient_email}',
      subtitle:
        'Convida a tua equipa para enviar e receber transferências no teu plano %{user_plan}.',
      list: {
        overview_item: 'Vista geral partilhada das transferências',
        storage_limit_item:
          'Armazenamento partilhado de %{storage_limit} extra por pessoa',
        branding_item: 'Branding de equipa partilhado',
        subscription_item: 'Assinatura e faturação partilhadas',
      },
      cta: 'Convidar equipa',
      dismiss_button: 'Hoje não',
    },
    second_viewing: {
      title: 'Cria uma equipa para transferências com ${first_recipient_email}',
      subtitle:
        'Convida a tua equipa para enviar e receber transferências no teu plano %{user_plan}.',
      list: {
        overview_item: 'Vista geral partilhada das transferências',
        storage_limit_item:
          'Armazenamento partilhado de %{storage_limit} extra por pessoa',
        branding_item: 'Branding de equipa partilhado',
        subscription_item: 'Assinatura e faturação partilhadas',
      },
      cta: 'Convidar equipa',
      dismiss_button: 'Ocultar para sempre',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'A tua conta foi atualizada',
    update_password: 'A tua palavra-passe foi alterada',
    update_subscription: 'O teu plano de pagamento foi atualizado',
    update_profile_success: 'O teu perfil foi atualizado',
    link_copied: 'Este link foi copiado para a tua área de transferência',
    copy_link_manual: 'Link selecionado – copia usando %{shortcut}',
    delete_transfer_success: 'Esta transferência foi eliminada',
    delete_transfers_success: 'As transferências foram eliminadas',
    update_expiry_success: 'A data de expiração foi atualizada',
    onboarding_success:
      'Obtém aqui uma lista das transferências, contactos, definições de perfil e afins',
    add_contact_success: 'Este contacto foi adicionado',
    edit_contact_success: 'Este contacto foi atualizado',
    remove_contact_success: 'Este contacto foi eliminado',
    already_signed_in: 'Você está conectado',
    cancel_subscription_success:
      'Temos pena de vê-lo partir - a sua assinatura foi cancelada',
    collect_app_banner_desc:
      'Pré-visualize, guarde e gira ficheiros a partir da Collect App.',
    contact_added_confirmation:
      'Foi adicionado um contacto à tua transferência',
    contact_recipient_locked_text:
      'Esta página serve para o proprietário receber ficheiros. Desejas enviar para outra pessoa?',
    forward_ready: 'A tua transferência está pronta para ser reencaminhada',
    mobile_app_banner_desc: 'Vê, guarda, gere ficheiros na aplicação',
    mobile_app_banner_title: 'Guarda na aplicação',
    reactivate_subscription_success:
      'Bem-vindo de volta! A tua conta foi reativada. ',
    refresh_transfer_upload_lost:
      'Tens a certeza de que pretendes cancelar o carregamento atual?',
    update_payment_success:
      'Os teus dados de pagamento foram atualizados com sucesso. Já está!',
    update_user: 'Os teus dados foram atualizados',
    current_team_notification:
      'Estás a usar %{plan} na conta da %{currentTeam}',
    display_name_updated: 'Título atualizado!',
    download_started:
      'O teu download já começou. Uma vez terminado, os ficheiros estarão no teu computador (muitas vezes na pasta de downloads).',
    logged_out:
      'Parece que foste desconectado a partir de outro navegador. Por favor conecta-te novamente.',
    project_delete:
      'Apagar <strong>%{projectName}</strong> e quaisquer ficheiros a que te tenham adicionado?',
    project_delete_success: '<strong>%{projectName}</strong> foi apagado',
    password_changed: 'Palavra-passe alterada',
    password_removed: 'Palavra-passe removida',
  },
  alert: {
    confirm_cancel_upload_image:
      'Tens a certeza de que pretendes cancelar o carregamento atual? ',
    cancel_recipient_locked: 'Cancelar',
    cancel_refresh_transfer_upload_lost: 'Não',
    confirm_refresh_transfer_upload_lost: 'Sim',
    go_to_transfer: 'Ir para a transferência',
    redirect_recipient_locked: 'Sim',
    stay: 'Ficar aqui',
    cancel_project_delete: 'Cancelar',
    confirm_project_delete: 'Eliminar',
  },
  force_update:
    'Aproxima-se algo emocionante. <a href="/" onClick=\'javascript:window.location.reload();\'>Atualiza o teu browser</a> para te certificares de que estás a usar a última versão do WeTransfer',
  user: {
    already_logged_in:
      'Já tens sessão iniciada – tens a certeza de que queres redefinir a tua palavra-passe?',
    roles: {
      admin: 'administrador',
      owner: 'proprietário',
      user: 'utilizador',
    },
    sign_out_and_reset: 'Terminar sessão e redefinir palavra-passe',
  },
  click_here: 'Clique aqui',
  cookiebox: {
    notice:
      '<bold>Encontras-te atualmente com sessão iniciada em</bold>, serás desconectado após limpar os teus cookies. As transferências passadas na tua conta não serão afetadas.',
  },
  notice: {
    general_issues:
      'As coisas não estão a funcionar como deveriam? Sabemos que é frustrante, mas aguenta mais um pouco, vamos voltar colocar tudo a funcionar <a target="_blank" href=%{link}>o mais rapidamente possível</a>',
    transfer_issues:
      'Estás a ter problemas com a sua transferência? Sabemos que é frustrante, mas aguenta mais um pouco, vamos voltar colocar tudo a funcionar <a target="_blank" href=%{link}>o mais rapidamente possível</a>',
    verification:
      'Olá. Necessitamos que <a href="/account">confirmes o teu e-mail</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Sobre | WeTransfer',
      advertise: 'Anunciar connosco | WeTransfer',
      apps: 'Aplicações gratuitas para Mac, iOS e Android | Aplicações WeTransfer',
      forgot_password: 'Reconfigurar a tua palavra-passe | WeTransfer Pro',
      help: 'Como enviar ficheiros grandes | Ajuda do WeTransfer',
      home: 'Transfere grandes ficheiros de forma fácil e gratuita | WeTransfer',
      plus: 'Fazer upgrade para enviar ficheiros maiores | WeTransfer Pro',
      sign_in: 'Aceder | WeTransfer Pro',
      sign_up: 'Inscrever | WeTransfer Pro',
      upgrade: 'Atualiza | WeTransfer Pro',
      pricing:
        'Preços | WeTransfer - Envia ficheiros grandes e partilha fotografias online - Grátis até 2 GB',
    },
    descriptions: {
      help: 'Precisas de apoio técnico da WeTransfer? Descobre como enviar ficheiros grandes na nossa secção de Ajuda rápida ou entra em contacto connosco.',
      social_help: 'Still haven’t found what you’re looking for?',
    },
  },
  splash: {
    footer: {
      or: 'ou',
      send_files: 'Só quero enviar os meus ficheiros',
      no_thanks: 'Não, obrigado',
    },
    heading: {
      line_1_free: 'WeTransfer é a melhor forma para enviar ficheiros grandes',
      line_2_free: 'Obtém mais do WeTransfer',
      free_account: 'Bem-vindo de volta. Queres oficializar a coisa?',
    },
    plan: {
      plus: {
        feature_10: 'Personaliza os teus e-mails',
        feature_11: 'Armazena até %{plus_storage_limit}',
        feature_12: 'Decide quando as transferências expiram',
        feature_13: 'Protege as tuas transferências com uma palavra-passe',
        feature_7: 'Personaliza o teu perfil',
        feature_8: 'Cria o teu próprio livro de endereços',
        feature_9: 'Personaliza o teu endereço URL do WeTransfer',
      },
      free_account: {
        cta: 'Inscrição gratuita',
        feature_1: 'Sem armazenamento',
        feature_2: 'Envia até %{free_transfer_limit}',
        feature_3: 'Reenviar e eliminar transferências',
        heading: 'Conta WeTransfer',
        price_label: 'Sempre gratuito',
      },
      pro: {
        cta: 'Adquira o WeTransfer Pro',
        feature_1: '%{storage_limit_pro} de armazenamento',
        feature_2: 'Envia e recebe até %{transfer_limit_pro}',
        feature_2_unlimited: 'Envia e recebe ficheiros sem limites de tamanho',
        feature_3: 'Reenviar e eliminar transferências',
        feature_4: 'Proteger as transferências com uma palavra-passe',
        feature_5: 'A tua própria página e endereço Pro',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: 'Queres adicionar %{recipient} à tua equipa?',
      text_content:
        'Os membros da equipa podem aceder às transferências de todos os membros, com armazenamento e branding partilhados. Isto não cancela a tua transferência.',
      cta: 'Vamos a isso',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Link copiado',
      copy: 'Copiar link',
      copy_again: 'Copiar novamente',
    },
    labels: {
      share: 'Partilhar esta trasferência',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'DICA PRO',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Experimenta o portals',
        dismiss: 'Agora não',
        text: 'Podes convidar clientes e colaboradores para visualizarem o teu trabalho e selecionarem os seus favoritos com o <strong>portals</strong>. Assim evitam os e-mails desnecessários.',
        title: 'Precisas de obter rapidamente feedback sobre o teu trabalho?',
      },
      'second-viewing': {
        cta: 'Experimenta agora o portals',
        dismiss: 'Não mostrar novamente',
        text: 'Obtém feedback rapidamente e partilha novas versões—tudo no mesmo lugar. Com <strong>portals</strong>, podes garantir uma passagem fácil do controlo para a revisão até à entrega final.',
        title: 'Enviaste o trabalho. E agora?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Ir para o Branding',
        text_2: 'Desejas adicionar os teus próprios vídeos ou imagens?',
      },
      individual: {
        cta: 'Configurar a página',
        text: 'Cria uma excelente impressão sempre que as pessoas descarregarem os teus ficheiros - adiciona vídeos ou imagens e escolhe o teu próprio endereço URL.',
        title: 'Marca presença com a tua própria página no WeTransfer',
      },
      invitee: {
        cta: 'Entendido',
        text_1:
          'Com a página personalizada do We Transfer para a tua equipa, irás marcar uma boa impressão sempre que partilhares o teu trabalho.',
        text_2:
          'Podes mudar os fundos de ecrã da tua equipa sempre em <strong>Branding</strong>.',
        title: 'Exibe o teu trabalho (de equipa)',
      },
      not_now: 'Agora não',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Configurar página',
                  premium: {
                    text: 'Todos te podem enviar transferências de qualquer dimensão a partir da página do WeTransfer da tua equipa.',
                  },
                  text: 'Todos te podem enviar %{transfer_limit_pro} transferências a partir da página do WeTransfer da tua equipa',
                },
                premium: {
                  transfer_link: {
                    text: 'Todos te podem enviar transferências de qualquer dimensão a partir de %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Todos podem enviar %{transfer_limit_pro} transferências de %{custom_link}',
                },
              },
              premium: {
                text: 'Todos te podem enviar transferências de qualquer tamanho a partir da página do WeTransfer da tua equipa - basta dares-lhes este link.',
              },
              regular: {
                cta: 'Entendi',
                text: 'Todos podem enviar<strong> %{transfer_limit_pro} </strong> transferências para a página do WeTransfer da tua equipa. Basta dar-lhes este link.',
                title: 'Um só lugar para tudo o que a tua equipa recebe',
              },
            },
            sent: {
              regular: {
                cta: 'Entendi',
                text: 'Bem-vindo ao resumo partilhado das transferências enviadas pela tua equipa. Agora, podes rastrear descarregamentos, modificar datas de expiração, e até modificar ou eliminar as transferências de outra pessoa - no entanto, pode ser simpático avisá-los antes de o fazeres!',
                title: 'Gere as transferências da tua equipa',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'O WeTransfer Plus agora é WeTransfer Pro com 1 TB de espaço — são 10 x mais. <a href="/transfers">Vem ver.</a>',
  },
  refer_friend: {
    title: 'Recomenda amigos',
    account: {
      description:
        'Tu e os teus amigos vão receber 10 $ cada quando se inscreverem no WeTransfer Pro ou Premium. Partilha o link de recomendação para receberes prémios em cartões pré-pagos, donativos à caridade ou cartões presente de centenas de parceiros.',
    },
    window: {
      link: 'Obter link de recomendação',
      send_another: 'Continuar',
      text: 'Tu e os teus amigos vão receber <strong>10 $</strong> cada quando se inscreverem no WeTransfer Pro ou Premium.',
      title: 'Recomendar um amigo',
      title_2: 'por enviares transferências.',
    },
    message: {
      success:
        'Tens aqui uma excelente amizade! Inscreve-te no WeTransfer Pro ou Premium e ambos vão receber um cartão pré-pago, donativos para a caridade ou cartões de presente no valor de 10 $.',
      self: 'O link de recomendação não está correto. Pede um link novo ao teu amigo para receberes 10 $ quando te inscreveres no WeTransfer Pro ou Premium.',
      fallback:
        'O link de recomendação não está correto. Pede um link novo ao teu amigo para receberes 10 $ quando te inscreveres no WeTransfer Pro ou Premium.',
      expired: 'O link de recomendação expirou.',
      dismiss: 'Ignorar',
    },
  },
  order_summary: {
    coupon: {
      link: 'Aplicar código promocional',
      input_placeholder: 'Código promocional',
      button_label: 'Aplicar',
      error_message:
        'Lamentamos, mas este código só pode ser utilizado para poupar numa assinatura %{billing_period}.',
      generic_error_message:
        'Lamentamos, mas este código não é compatível com esta assinatura',
      input_error_message: 'Bem, este código não é válido.',
      pill_label: {
        percentage: '-%{percentage}%',
      },
    },
    total: 'Total',
  },
  mobile_verify: {
    title: 'Já está tudo pronto',
    subtitle:
      'O seu e-mail foi verificado - agora pode utilizar a aplicação para enviar e receber transferências.',
    cta: 'Abrir a aplicação WeTransfer',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'O teu plano atual de <b>%{formattedintervaltotal}</b> /%{subscriptioninterval} será renovado automaticamente em <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'O teu plano atual de <b>%{formattedTeamWorkspaceCost}</b> /%{subscriptioninterval} <br>(%{membercount} x %{tieramount}) será renovado automaticamente em <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'A tua próxima data de pagamento é <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b> /%{interval}',
    team_upgrade_calculation: '(%{membercount} membros x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Sem limites de tamanho de transferências',
    premium_feature_two: 'Armazenamento ilimitado',
    premium_feature_three: 'Portais e revisões sem limites',
    premium_feature_four:
      'Ver <a class="all-benefits-link" href="%{all_benefits_href}">todos os benefícios</a>',
    premium_switch_cta_text: 'Switch to premium',
    pill_text: 'Plano atual',
    member_count: '%{membercount} membros',
    see_all_benefits: 'Ver todos os benefícios do plano',
    pending_downgrade_current_subscription:
      'A assinatura do workspace foi cancelada e terminará em <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      'Mudaste de ideias? Não entres em pânico, é fácil pôr as coisas a funcionar de novo.',
    pending_downgrade_reactivate_cta: 'Reativar o Pro',
    pending_downgrade_payment: 'Não tens pagamentos próximos',
    update_payment_cta: 'Atualização dos dados de pagamento',
    cancel_plan:
      'Se cancelares a assinatura, poderás aceder ao teu workspace %{planName} até %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Em seguida, o teu workspace será atualizado para versão inferior para o plano gratuito, e as transferências existentes expirarão após 28 dias.',
    pending_payment_text:
      'To see your plan and payment information, please complete your payment or cancel your order.',
    learn_more: 'Learn more about plans and pricing',
  },
  time: {
    days: {
      monday: 'Segunda-feira',
      tuesday: 'Terça-feira',
      wednesday: 'Quarta-feira',
      thursday: 'Quinta-feira',
      friday: 'Sexta-feira',
      saturday: 'Sábado',
      sunday: 'Domingo',
    },
    months: {
      january: 'Janeiro',
      february: 'Fevereiro',
      march: 'Março',
      april: 'Abril',
      may: 'Maio',
      june: 'Junho',
      july: 'Julho',
      august: 'Agosto',
      september: 'Setembro',
      october: 'Outubro',
      november: 'Novembro',
      december: 'Dezembro',
    },
    remaining: {
      minutes: {
        zero: 'Menos de um minuto restante',
        one: 'Cerca de 1 minuto restante',
        other: 'Cerca de %{count} minutos restantes',
      },
      hours: {
        one: 'Cerca de 1 hora restante',
        other: 'Cerca de %{count} horas restantes',
      },
    },
  },
  download: {
    shortcut:
      'Pressione %{command} para ver o<br />progresso da transferência.',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Enviar até %{size}',
    progress: {
      busy: 'A transferir...',
    },
    buttons: {
      add: 'Adicionar ficheiros',
      transfer: 'Transferir',
      forward: 'Encaminhar',
      add_ios6: 'Adicione fotos e vídeos',
      add_ios7: 'Adicione fotos',
    },
    forward: {
      done: 'Encaminhamento completo',
    },
    friend_email: {
      title: 'E-mail do amigo',
      more: 'Adicionar mais amigos',
    },
    your_email: {
      title: 'O seu e-mail',
    },
    message: {
      title: 'Mensagem',
    },
    done: {
      title: 'Transferência completa',
      link: 'Copie o seu link para fazer a transferência:',
      copied: {
        title: 'Copiado!',
        text: 'Foi copiado o link de transferência.',
      },
    },
    more_html: 'Adicione mais ficheiros<span>(%{size})</span>',
    too_many_recipients:
      'Parece que introduziu demasiados endereços de email. Lembre-se: há espaço até %{count} pessoas de uma vez.',
    completed: '%{size} de %{total} concluído(s)',
    addresses: {
      one: '%{count} endereço',
      other: '%{count} endereços',
      remove: 'Quer remover %{address} dos seus destinatários anteriores?',
    },
    ads: {
      plus: {
        title: 'Obtenha mais do WeTransfer<br />com Pro',
        text: "<ul><li>Uploads de tamanho grande</li><li>Transferências personalizadas com o seu próprio padrão de fundo</li><li>Transferências protegidas por senha</li><li>Armazenamento de longo prazo</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Saiba mais</a></p>",
      },
      plus2: {
        title:
          'Impressione<br />com a sua<br />página de transferências personalizada',
        text: "<p>Use os seus próprios padrões de fundo e WeTransfer URL personalizado (yourname.wetransfer.com)<br />para impressionar os destinatários.</p><p><a target='_blank' href='/pro?trk=inapp'>Saiba mais</a></p>",
      },
      plus3: {
        title: 'Administre as suas transferências de maneira mais inteligente',
        text: "<p>Este carregamento será apagado após 1 semana, mas com WeTransfer Pro você pode armazenar por prazo indeterminado, encaminhar e apagar instantaneamente, sem precisar carregar novamente.</p><p><a target='_blank' href='/pro?trk=inapp'>Saiba mais</a></p>",
      },
      plus4: {
        title: 'Tenha proteção extra<br />para os seus ficheiros',
        text: "<p>Com WeTransfer Pro, você pode proteger ficheiros importantes ou confidenciais com uma senha. Assim eles nunca cairão em mãos erradas.</p><p><a target='_blank' href='/pro?trk=inapp'>Saiba mais</a></p>",
      },
      facebook: {
        title: 'Junte-se à WeTransfer comunidade do Facebook',
        text: "<p>Veja as últimas notícias, ganhe prêmios, descubra novos artistas, leia entrevistas e muito mais.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Descubra mais</a>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email:
        'Desculpe, apenas o e-mail é suportado ao reenviar uma transferência.',
      connect_twitter:
        'A sua conta de Twitter ainda não está ligada ao WeTransfer.',
      connect_facebook:
        'A sua conta de Facebook ainda não está ligada ao WeTransfer.',
      transferproblems: {
        title: 'Problema na transferência',
        text: 'Não queremos desiludi-lo mas aconteceu alguma coisa de errado com a transferência.',
      },
      limitreached: {
        title: 'Limite de armazenamento',
        text: 'Atingiu o seu limite de 1 TB. Elimine algumas transferências mais velhas para enviar novos ficheiros.',
      },
      blocked: {
        title: 'Problema na transferência',
        text: 'O computador diz que não. Desculpe mas foi bloqueado do WeTransfer.',
      },
      upload_error: {
        title: 'Problema na transferência',
        text: 'Não queremos desiludi-lo mas aconteceu alguma coisa de errado com a transferência.',
      },
      unavailable: {
        title: 'Erro de transferência',
        text: 'Desculpe, esta transferência já foi eliminada e, portanto, não pode ser reencaminhada.',
      },
      startswithdot: {
        title: 'Ups',
        text: 'Um (ou mais) dos seus ficheiros tem um nome que começa com um ponto final. Não vai dar. Por favor renomeie o(s) ficheiro(s) e volte a tentar adicioná-lo(s).',
      },
      startswithspace: {
        title: 'Ups',
        text: 'Um (ou mais) dos seus ficheiros tem um nome que começa com um espaço. Não vai dar. Por favor renomeie o ficheiro(s) e volte a tentar adicioná-lo(s).',
      },
      containsreturn: {
        title: 'Ups',
        text: 'Um (ou mais) dos seus ficheiros tem um nome de ficheiro que contém um parágrafo. Não sabemos bem como conseguiu fazer isto, mas não vai funcionar. Por favor mude o nome do ficheiro(s) e volte a tentar adicioná-lo(s).',
      },
      alreadyinlist: {
        title: 'Bolas',
        text: 'Parece que um dos seus ficheiros tinha o mesmo nome que outro ficheiro que já tinha selecionado. Faça uma pequena alteração!',
      },
      transfertoobig: {
        title: 'Uh-oh',
        text: 'Lamentamos muito mas não podemos transferir mais de %{upload_limit} GB de momento.',
      },
      filetoobig: {
        title: 'Uh-oh',
        text: 'Lamentamos muito mas não podemos transferir mais de %{upload_limit} GB de momento.',
      },
      zerobytes: {
        title: 'Ops!',
        text: 'Um (ou mais) dos seus ficheiro(s) está vazio ou não pode ser lido.',
      },
      ioerror: {
        title: 'Falha',
        text: 'Um (ou mais) dos seus ficheiros não pode ser lido ou é maior que %{upload_limit} GB. Não vai dar.',
      },
      filenametoolong: {
        title: 'Bolas',
        text: 'Um (ou mais) dos seus ficheiros tem um nome de ficheiro com mais de 250 caracteres. Não podemos aceitar nomes de ficheiro maiores que isto, portanto volte a nomear o ficheiro.',
      },
      nofolders: {
        title: 'Uh-oh',
        text: 'Desculpe, a pasta dos uploads ainda não funciona. Tente comprimi-la primeiro.',
      },
      nofiles: {
        title: 'Ups',
        text: 'Ainda não adicionou quaisquer ficheiros.',
      },
      norecipients: {
        title: 'Duh!',
        text: 'Parece que se esqueceu de introduzir o endereço de e-mail do destinatário.',
      },
      toomanyrecipients: {
        title: 'Bolas',
        text: 'Desmaiados recipientes.',
      },
      bigmessage: {
        title: 'Ups',
        text: 'A sua mensagem é demasiado longa. Tente encurtá-la.',
      },
      nosender: {
        title: 'A sério?',
        text: 'Esqueceu-se de introduzir o seu próprio endereço de e-mail. Onde está com a cabeça?',
      },
      senderemailinvalidformat: {
        title: 'Uh-oh',
        text: 'O seu endereço de e-mail parece não estar correto. Tenha atenção, soletre bem!',
      },
      probablynotcopied: {
        title: 'Ups',
        text: 'Parece que não copiou o link.',
      },
      recipientemailinvalidformat: {
        title: 'Ups',
        text: 'Introduziu incorretamente um dos endereços de e-mail dos seus amigos.',
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Bolas',
        text: 'Um (ou mais) dos seus ficheiros tem um nome de ficheiro que contém uma barra inversa. Não podemos aceitá-la e portanto vai ter de renomear os ficheiros para que não contenham este caracter.',
      },
      title: 'Ups',
      text: "iOS7 não lhe permite enviar vídeos através do nosso sítio, mas se usar a nossa <a href='%{wetransfer_ios_app_store_url}'> fantástica aplicação WeTransfer</a>, você pode!",
    },
    tips: {
      maxfilesize_tip: {
        title: 'Dica',
        text: 'Pode enviar até 2 GB por transferência. E o que é ainda melhor: pode fazer transferências tantas vezes quanto as que desejar.',
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Importante',
        text: "A sua conta Pro pode enviar até 20 GB por transferência, mas o seu navegador está a impedi-la de o fazer. <a href='/questions/33'>Clique aqui para mais informações.</a>",
      },
      recipients_tip: {
        title: 'Dica',
        text: 'Pode inserir até %{email_limit} endereços de e-mail para os quais queres fazer envios. Se apenas quiser um link de transferência, clique no botão de partilha, abaixo.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Dica',
        text: 'Coloque o seu endereço de e-mail aqui para que possamos contactá-lo quando os ficheiros forem transferidos.',
      },
      expire_tip: {
        title: 'Dica',
        text: 'Agora, já pode alterar a data de expiração das suas transferências Pro.',
      },
      message_tip: {
        title: 'Dica',
        text: 'Quer enviar uma mensagem juntamente com os ficheiros aos seus amigos? Aqui tem a sua oportunidade - embora não tenha de o fazer.',
      },
      share_tip: {
        title: 'Dica',
        text: 'Mude a forma de partilhar os seus ficheiros. Envie-os por mail ou cole um link de transferência.',
        text_plus:
          'Mude a forma de partilhar os seus ficheiros. Envie-os por e-mail, Twitter, Facebook, ou cole um link de transferência.',
      },
      download: {
        title: '',
        chrome:
          "O download funciona de maneira diferente do que acontecia antes. Agora fazemos o download de todos os ficheiros pelo navegador web, portanto não irá ver o progresso no WeTransfer. Além disso, poderá também acontecer que não lhe seja perguntado onde quer guardar o ficheiro. O progresso do download deve ser visível no fundo da janela do seu navegador e o seu ficheiro será guardado, por defeito, na sua pasta de Downloads. <a href='/questions/24' target='_blank'>Descubra aqui como mudar este comportamento</a>.",
        firefox:
          "O download funciona de maneira diferente do que acontecia antes. Agora fazemos o download de todos os ficheiros pelo navegador web, portanto não irá ver o progresso no WeTransfer. Além disso, poderá também acontecer que não lhe seja perguntado onde quer guardar o ficheiro. O progresso deve ser visível na janela de Download do seu navegador e o seu ficheiro será guardado, por defeito, na sua pasta de Downloads. <a href='/questions/24' target='_blank'>Descubra mais</a>.",
        safari:
          "O download funciona de maneira diferente do que acontecia antes. Agora fazemos o download de todos os ficheiros pelo navegador web, portanto não irá ver o progresso no WeTransfer. Além disso, poderá também acontecer que não lhe seja perguntado onde quer guardar o ficheiro. O progresso deve ser visível no canto superior direito da janela do seu navegador e o seu ficheiro será guardado, por defeito, na sua pasta de Downloads. <a href='/questions/24' target='_blank'>Descubra mais</a>.",
        old_explorer:
          "O download funciona de maneira diferente do que acontecia antes. Agora fazemos o download de todos os ficheiros pelo navegador web, portanto não irá ver o progresso no WeTransfer. Além disso, poderá também acontecer que não lhe seja perguntado onde quer guardar o ficheiro. Pode também ver um alerta de segurança no cimo da janela do seu navegador web. <a href='/questions/24' target='_blank'>Descubra mais</a>.",
        explorer:
          "O download funciona de maneira diferente do que acontecia antes. Agora fazemos o download de todos os ficheiros pelo navegador web, portanto não irá ver o progresso no WeTransfer. Além disso, poderá também acontecer que não lhe seja perguntado onde quer guardar o ficheiro. O progresso deve ser visível no fundo da janela do seu navegador (pode ser necessário que clique primeiro em Guardar) e o seu ficheiro será guardado, por defeito, na sua pasta de Downloads. <a href='/questions/24' target='_blank'>Descubra mais</a>.",
        settings:
          'Você pode alterar o local onde são guardados os download por padrão nas configurações de seu navegador.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding:
      'Encaminhar esta transferência vai limpar o formulário, tem a certeza?',
    is_busy: 'Desculpe, não podemos realizar esta operação agora.',
  },
  mobile_app: {
    remember_choice: 'Não mostrar esta mensagem novamente',
    uploader: {
      description:
        'Atualmente, o nosso site não está otimizado para dispositivos móveis. Mas temos uma fantástica aplicação móvel.',
      app_name: 'WeTransfer',
      download: 'Descarregar a aplicação',
      continue: 'Continuar para WeTransfer.com',
    },
    downloader: {
      title: 'Os seus ficheiros estão prontos para descarregar',
      description_ios:
        'Agrupámos os seus ficheiros num ficheiro ZIP. Irá precisar de uma aplicação para extrair e ver os ficheiros. Achamos que o <a href="https//itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a> é uma boa aplicação para o fazer.',
      description_android:
        'Agrupámos os seus ficheiros num ficheiro ZIP. Irá precisar de uma aplicação para extrair e ver os ficheiros. Achamos que o <a href="https//play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a> é uma boa aplicação para o fazer.',
      continue: 'Compreendi',
    },
  },
};
